export const downloads = {
  timestamps: [
    1655769600000, 1656201600000, 1656806400000, 1657411200000, 1658275200000,
    1658707200000, 1659225600000, 1659830400000, 1660521600000, 1661040000000,
    1661731200000, 1662336000000, 1662940800000, 1663545600000, 1664150400000,
    1664668800000, 1665360000000, 1665878400000, 1666483200000, 1667260800000,
    1667779200000, 1668297600000, 1668988800000, 1669507200000, 1670112000000,
    1670716800000, 1671494400000, 1672012800000, 1672531200000, 1673222400000,
    1673740800000, 1674432000000, 1674950400000, 1675555200000, 1676160000000,
    1677456000000, 1678060800000, 1678579200000, 1679270400000, 1679875200000,
    1680480000000, 1681171200000, 1681689600000, 1682294400000, 1682812800000,
    1683504000000, 1684022400000, 1684713600000, 1685232000000, 1685836800000,
    1686441600000, 1687046400000, 1687651200000, 1688256000000, 1688860800000,
    1689552000000, 1690070400000, 1690675200000, 1691366400000, 1691884800000,
    1692576000000, 1693180800000, 1695081600000, 1695513600000, 1696204800000,
    1696723200000, 1697328000000, 1698019200000, 1698624000000, 1701907200000,
    1702252800000, 1702857600000, 1703635200000, 1704153600000, 1704585600000,
    1705190400000, 1705881600000, 1706400000000, 1707091200000, 1707696000000,
    1708300800000, 1708905600000, 1709424000000, 1710028800000, 1710720000000,
    1711238400000, 1711843200000, 1712534400000, 1713052800000, 1713657600000,
    1715558400000, 1716076800000, 1716768000000, 1717372800000, 1717977600000,
    1718582400000, 1719187200000, 1719792000000, 1720310400000, 1720915200000,
    1721606400000, 1723507200000, 1724025600000, 1724630400000, 1725235200000,
    1725840000000, 1726444800000, 1728259200000, 1728777600000, 1729382400000,
    1730073600000, 1730678400000, 1731369600000, 1731888000000, 1732492800000,
    1733011200000, 1733616000000, 1734307200000, 1734912000000, 1736121600000,
    1736726400000, 1737331200000, 1737936000000, 1738540800000, 1739059200000,
    1739664000000, 1740268800000, 1740960000000, 1741478400000, 1742083200000,
    1742688000000, 1743292800000, 1743984000000, 1744588800000, 1745107200000,
    1745712000000, 1746316800000, 1747094400000, 1747526400000, 1748217600000,
    1748908800000, 1749340800000, 1750032000000, 1750550400000, 1750684713281,
    1751156934737, 1751761712100, 1752366561594, 1752971393795, 1753576193596,
  ],
  versionDownloads: {
    '7.16.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 24561, 98296, 21522, 21504, 20054, 17252, 17808, 17885, 16732, 16845, 15399,
      16146, 16126, 14954, 6153, 10982, 11179, 8699, 8868, 10407, 9115, 8616, 7862,
      7515, 5796, 6620, 7118, 6820, 6617, 5061, 5103, 4173, 4922, 5233, 5370, 5095,
      5056, 4566, 4823, 4875, 4917, 4639, 4381, 5319, 4173,
    ],
    '6.19.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 124329, 154099, 81586, 58584, 47747, 45709, 37719, 38801, 35393, 32728,
      23770, 24613, 23330, 22633, 23282, 25673, 25776, 28162, 17753, 24791, 24147,
      20235, 18801, 20809, 21624, 18257, 18991, 18693, 15047, 13060, 13220, 12098,
      11894, 12289, 11155, 9481, 9933, 9920, 9770, 4330, 9260, 9097, 6806, 7629,
      10407, 9223, 8732, 7915, 6877, 6124, 7621, 7358, 6799, 7417, 6782, 5591, 5271,
      5630, 5826, 5747, 5689, 5731, 5190, 4995, 5024, 5375, 5512, 5552, 5115, 5219,
    ],
    '6.19.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      23475, 110783, 50985, 23397, 23216, 22028, 20669, 19384, 15502, 15095, 15831,
      13852, 13569, 11964, 14277, 14984, 13607, 15932, 17642, 14555, 14061, 11732,
      12665, 11910, 7995, 7195, 6864, 6493, 7473, 7519, 5781, 6742, 5590, 5797, 6642,
      6956, 5924, 5129, 4090, 4074, 5449, 5215, 2349, 4968, 5955, 3114, 4103, 5737,
      4640, 4029, 3840, 4553, 3071, 4560, 4173, 4434, 4369, 3746, 4140, 4395, 4764,
      4525, 3994, 4715, 6611, 3727, 4123, 4286, 5775, 3089, 3385, 3672, 4220,
    ],
    '5.17.12': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 18376, 58759,
      24625, 20527, 16498, 12536, 6147, 10237, 11325, 10733, 10020, 10662, 11666,
      8380, 8540, 7491, 8029, 8446, 6641, 6675, 6423, 5902, 5948, 5341, 4693, 4854,
      4433, 3923, 2580, 2660, 2510, 2684, 2305, 2716, 2517, 2531, 2418, 2378, 2527,
      2345, 1232, 2680, 2444, 2226, 2166, 2880, 2561, 6122, 1909, 2049, 1073, 489,
      1158, 1964, 1955, 2116, 6964, 2059, 2296, 1881, 5695, 2109, 2040, 1877, 1136,
      1067, 1065, 945, 890, 843, 674, 3270, 790, 827, 744, 724, 1069, 617, 624, 694,
      685, 907, 813, 925, 815, 1220, 886, 1048, 974, 1848, 1626, 725, 999, 779, 728,
      875, 930, 795, 1058, 1010, 587, 678, 704, 975, 1081, 1172, 763, 820, 1111,
      1393, 1375, 969, 864, 889, 768, 805, 1054, 977, 1239, 1166, 1036, 1055, 1062,
      816, 598, 633, 909, 894,
    ],
    '7.0.0-beta.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 218, 51, 50, 41, 44, 12, 8, 6, 7, 9, 11, 17, 23, 17, 18, 17, 24, 25, 22,
      18, 25, 18, 17, 32, 28, 33, 30, 11, 26, 10, 17, 7, 3, 2, 1, 0, 0, 2, 0, 1, 0,
      0, 1, 0, 0, 1, 4, 0, 4, 2, 1, 0, 1, 3, 1, 0, 1, 0, 0, 1, 4, 4, 10, 2, 2, 1, 2,
      3, 20, 8,
    ],
    '5.0.0-beta.7': [
      2205, 1195, 1370, 1437, 1174, 818, 898, 899, 864, 827, 812, 782, 697, 747, 829,
      682, 777, 748, 590, 768, 661, 618, 559, 497, 2971, 436, 424, 435, 314, 461,
      531, 432, 373, 1267, 552, 534, 1086, 377, 344, 375, 2415, 297, 260, 338, 329,
      262, 280, 237, 254, 1184, 243, 258, 342, 306, 332, 271, 204, 240, 258, 236,
      174, 180, 151, 182, 835, 181, 155, 128, 170, 1419, 225, 213, 155, 84, 141, 164,
      150, 74, 1059, 143, 132, 190, 1820, 143, 153, 112, 92, 98, 129, 81, 117, 73,
      68, 1595, 80, 77, 129, 85, 417, 85, 94, 88, 53, 40, 77, 36, 48, 198, 47, 43,
      103, 462, 270, 32, 46, 61, 49, 40, 38, 30, 49, 48, 18, 29, 103, 55, 24, 49, 35,
      45, 25, 42, 67, 43, 38, 38, 59, 58, 95, 56, 54, 43, 55, 57, 56, 50, 89, 96,
      100, 108,
    ],
    '7.21.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 23638, 121053, 50816, 41711, 25201, 24404, 19008, 20234, 16875,
      16798, 7282, 13917, 12746, 10791, 12007, 14231, 13034, 11799, 12478, 13347,
      10513, 12797, 11304, 10173, 11499, 11086, 10095, 9528, 9867, 11431, 9167,
      11629, 13171, 11107, 9102, 9012, 9320, 8103, 9428, 10225, 17315,
    ],
    '6.11.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 8368, 56287, 22535, 6604, 10575, 8819, 8615, 8214, 10524,
      7765, 5580, 5393, 5216, 3626, 1859, 2419, 4944, 4453, 3938, 4179, 4023, 4969,
      6128, 4561, 4348, 3890, 3675, 3209, 2737, 3034, 3344, 2948, 3514, 3886, 2100,
      2596, 2867, 2195, 1886, 1514, 2045, 2095, 2869, 3361, 2488, 2020, 2425, 2076,
      1716, 1488, 2063, 2299, 5203, 4479, 1640, 1997, 1426, 1425, 1277, 1681, 470,
      1062, 1186, 1306, 1440, 1629, 1505, 983, 914, 847, 680, 1155, 1187, 2501,
      16632, 19703, 17046, 11506, 18267, 17379, 13838, 12559, 13232, 12396, 11721,
      11576, 13629, 15043, 13259, 12629, 14598,
    ],
    '7.23.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 314, 72, 33, 12, 26, 30, 38, 53,
      53, 41, 2, 22, 12, 7, 2, 11, 3, 14, 20, 16, 6, 4, 13, 20, 15, 15, 13, 15, 5,
      39, 22,
    ],
    '6.0.0-beta.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 104, 131, 20, 28, 5, 5, 4, 2, 4, 5, 6, 5, 16, 16, 18, 9, 5,
      4, 1, 2, 2, 8, 7, 4, 3, 3, 5, 2, 3, 0, 5, 1, 7, 13, 4, 4, 3, 10, 7, 4, 6, 4, 1,
      18, 20, 22, 80, 13, 13, 12, 17, 10, 10, 12, 9, 10, 9, 12, 12, 15, 12, 20, 20,
      18, 18, 13, 23, 19, 25, 18, 20, 22, 26, 21, 19, 7, 4, 0, 4, 11, 10, 4, 5, 4, 6,
      4, 4, 1, 3, 6, 4, 3, 4, 3, 0, 1, 3, 5, 2, 3, 2, 0, 3, 5, 2, 0, 1, 4, 3, 2, 2,
      2, 2, 2, 1, 1, 22, 8,
    ],
    '5.15.1': [
      0, 0, 0, 0, 0, 0, 0, 11714, 49569, 21520, 17693, 15736, 12299, 12133, 10995,
      10837, 9190, 9291, 8132, 7076, 6169, 6648, 6156, 4266, 5176, 4643, 4708, 3822,
      2335, 3188, 4244, 3073, 3477, 3640, 3640, 3137, 3288, 3533, 3024, 2820, 2175,
      2624, 2973, 2917, 3329, 2870, 2989, 2954, 3386, 2770, 3057, 3215, 2898, 2837,
      2683, 2812, 1962, 2655, 2875, 2402, 2533, 2540, 1369, 2481, 13112, 2210, 2157,
      1960, 2088, 3078, 1964, 1594, 933, 465, 993, 1422, 1676, 1825, 3843, 1836,
      1807, 2119, 4641, 2168, 1790, 2659, 1684, 1592, 1870, 2111, 2022, 2000, 2342,
      3254, 1562, 2231, 1661, 2392, 1975, 2883, 2246, 2427, 2655, 2451, 2970, 1671,
      1938, 3800, 2118, 2266, 1911, 6034, 4345, 1817, 1760, 1330, 1513, 1778, 1089,
      383, 996, 813, 569, 552, 1175, 984, 812, 1039, 809, 735, 952, 1069, 699, 715,
      712, 1122, 938, 1240, 1469, 1293, 888, 1042, 1290, 1206, 1243, 1381, 933, 756,
      1099, 905,
    ],
    '6.0.0-alpha.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 138, 662, 59, 31, 44, 3, 8, 1,
      1, 1, 0, 1, 0, 1, 0, 1, 0, 2, 3, 13, 82, 150, 304, 229, 191, 198, 307, 319,
      314, 122, 162, 312, 230, 243, 245, 227, 217, 250, 192, 239, 241, 192, 275, 174,
      677, 493, 277, 320, 431, 508, 477, 395, 303, 271, 275, 169, 88, 12, 77, 241,
      188, 414, 488, 363, 348, 455, 571, 442, 439, 305, 262, 193, 8, 12, 7, 6, 10,
      159, 14, 14, 14, 13, 47, 17, 16, 15, 15, 14, 17, 18, 13, 5, 3, 1, 1, 141, 118,
      2, 1, 0, 0, 0, 2, 0, 1, 0, 0, 0, 2, 0, 0, 1, 1, 1, 1, 0, 0, 0, 2, 0, 1, 1, 0,
      1, 0, 0, 1, 2, 2, 1, 1, 0, 20, 7,
    ],
    '5.17.11': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13692, 59145,
      22101, 21339, 18241, 20317, 15139, 8190, 14295, 16018, 15669, 14805, 13676,
      13141, 12182, 11885, 12266, 12340, 12227, 9624, 8365, 9240, 8959, 9192, 10286,
      9540, 9764, 7950, 8651, 9232, 9692, 8951, 8345, 7206, 8390, 8342, 7756, 7649,
      7691, 7644, 8747, 6096, 9374, 8350, 7693, 6692, 6545, 6724, 10312, 6608, 5095,
      2871, 1282, 2455, 3774, 3680, 3609, 10468, 4076, 3417, 3556, 8567, 3253, 3449,
      2984, 2530, 2464, 2935, 3304, 2683, 3194, 2234, 7478, 2220, 2720, 1889, 1742,
      3052, 1767, 1643, 1401, 1363, 1804, 1755, 1610, 1547, 1639, 1699, 1456, 1618,
      4257, 3856, 1482, 1223, 1388, 1379, 1458, 1305, 514, 1285, 1184, 1066, 1167,
      1657, 1461, 1538, 1773, 1561, 1385, 1098, 1614, 1230, 1579, 1546, 1597, 1549,
      1183, 1244, 1019, 1068, 916, 966, 1431, 1434, 1273, 1085, 1416, 811, 981,
    ],
    '7.15.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 81298, 39353, 25136, 25613, 21526, 20773, 18915, 18111, 17556, 15234, 13423,
      14775, 15997, 16216, 4553, 10032, 13156, 11266, 9177, 14366, 10680, 11372,
      11142, 10501, 9479, 10518, 13222, 13778, 13503, 13002, 13077, 8766, 13295,
      14921, 12409, 10535, 9843, 10714, 9409, 9552, 10512, 9450, 10453, 10816, 11639,
    ],
    '5.17.22': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 19756, 71669, 17796, 15917, 14808, 12706, 10966, 9093,
      8398, 9673, 9367, 10552, 8808, 8488, 8722, 9261, 8156, 8849, 9008, 7876, 7497,
      5615, 6462, 5480, 5929, 5425, 5407, 5129, 4986, 3188, 6879, 12085, 11830, 5818,
      8971, 11247, 3889, 3837, 4853, 2844, 1421, 2670, 4768, 4584, 4292, 4815, 4876,
      4860, 4484, 11760, 4840, 4427, 4544, 2686, 3831, 4286, 4205, 4403, 3705, 4125,
      9588, 4161, 3527, 3127, 3511, 4843, 3550, 3219, 2676, 2271, 2791, 2622, 3045,
      3127, 4387, 3073, 3078, 3454, 7397, 5509, 2864, 2910, 3305, 3110, 3137, 2753,
      1272, 2644, 2979, 2990, 2944, 3858, 3783, 3244, 3539, 3589, 3072, 3387, 3122,
      3379, 3509, 2411, 3254, 2186, 3484, 2784, 3550, 3885, 3989, 3411, 4488, 4294,
      4746, 4237, 4786, 3202, 2803,
    ],
    '5.16.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17188, 62097, 28823, 24236, 20354, 17614, 16960,
      14663, 14604, 12793, 10835, 10150, 10121, 8699, 9794, 9039, 8540, 7445, 4445,
      6208, 8125, 8446, 7913, 8127, 7743, 6833, 7792, 6350, 7116, 6916, 5291, 5006,
      5952, 5608, 5513, 4345, 5012, 5091, 4931, 5212, 5510, 5252, 5108, 5471, 5037,
      5441, 5886, 4872, 5506, 5431, 5042, 5543, 3519, 5402, 21704, 4506, 4930, 4461,
      4698, 5751, 3700, 4104, 2900, 1285, 2182, 3731, 5277, 4844, 7927, 4169, 3998,
      3932, 7565, 4388, 4634, 4294, 3429, 4015, 4104, 4038, 3855, 4173, 3445, 6584,
      3756, 3809, 3240, 3968, 4300, 4006, 3688, 3865, 3846, 3683, 3334, 2642, 2764,
      5324, 2584, 2653, 2259, 10287, 7065, 2321, 2441, 2473, 2389, 2362, 2618, 1978,
      2390, 2649, 2130, 2147, 2682, 2579, 2481, 2382, 2078, 1952, 2465, 2434, 2519,
      2368, 2325, 2518, 2344, 2808, 2668, 2295, 2368, 2273, 2346, 2172, 2157, 2054,
      2425, 2745, 2911, 2139,
    ],
    '8.0.0-alpha.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 120, 5, 0, 1, 0, 0, 0, 0, 0, 1, 2,
      0, 1, 1, 0, 2, 0, 0, 1, 0, 1, 1, 0, 1, 2, 3, 2, 1, 2, 1, 20, 8,
    ],
    '7.29.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 34694, 86725, 29888, 28522, 25185, 21232, 20917, 20267, 18936,
      18888, 19063, 15824, 19565, 18551, 15667,
    ],
    '8.4.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 23862, 48996, 26304, 18174, 14572, 14059, 11258,
      8579, 8009, 8748, 8068,
    ],
    '7.5.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13354, 58990, 21599, 14379, 11594,
      11019, 10297, 9216, 7218, 6238, 5970, 6614, 6738, 5161, 4686, 4434, 4726, 4601,
      5016, 4519, 4407, 4381, 4356, 4259, 4619, 4508, 4037, 1287, 3505, 3471, 3035,
      2727, 2713, 3135, 3452, 3297, 3258, 2413, 2753, 2350, 2355, 2410, 3096, 2455,
      2298, 2348, 2495, 2239, 2093, 1833, 2088, 2328, 2319, 2058, 1926, 2088, 2132,
      1740,
    ],
    '7.6.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11595, 67436, 24004, 17631, 15854,
      12305, 12296, 11813, 10564, 9460, 9658, 9624, 7533, 8312, 7423, 6543, 5472,
      5063, 4742, 4580, 4683, 4902, 3888, 3941, 3717, 4175, 2115, 3805, 3831, 3247,
      3239, 3594, 3853, 4186, 4405, 3855, 2992, 3720, 2746, 3203, 3049, 2752, 2496,
      2456, 3200, 3781, 2967, 2799, 3832, 4716, 4632, 4595, 3204, 2619, 2692, 2146,
      2715,
    ],
    '6.18.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13419, 84749, 16078,
      7401, 13020, 17332, 15679, 16070, 14991, 15363, 13288, 15136, 14623, 13225,
      12418, 12077, 8100, 9367, 9620, 9454, 9070, 8669, 8158, 9880, 8893, 8154, 7514,
      8422, 6890, 7162, 7259, 7236, 6495, 6123, 6277, 5682, 7204, 5708, 5428, 5603,
      4898, 5214, 4999, 5355, 5106, 3953, 4638, 3876, 4500, 2740, 4207, 4968, 3050,
      2529, 3951, 3591, 4051, 4055, 3841, 3505, 5158, 6026, 3932, 3563, 3119, 3535,
      3345, 4037, 4441, 2777, 4696, 3602, 4276, 4495, 4354, 4118, 3638, 2528, 2579,
      2973,
    ],
    '8.0.0-alpha.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 184, 129, 65, 139, 181, 101,
      214, 144, 129, 102, 56, 51, 1, 73, 8, 0, 1, 1, 0, 1, 57, 50, 5, 2, 2, 2, 1, 3,
      1, 20, 9,
    ],
    '5.17.25': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 28041, 90396, 44559, 40518, 34592, 24615, 24528,
      24927, 24730, 21860, 20805, 20326, 18267, 19059, 17033, 19070, 19069, 17262,
      16263, 9103, 10418, 9716, 9630, 9354, 8564, 8498, 8399, 5442, 8956, 7850, 7213,
      8020, 7808, 7195, 5902, 5560, 5569, 4035, 2143, 3098, 5080, 4869, 5152, 5623,
      5350, 5045, 5241, 45815, 5269, 4510, 4167, 3849, 4435, 4287, 3866, 3107, 2971,
      3203, 13232, 2503, 3017, 2665, 3362, 4104, 2874, 3177, 3222, 2569, 2732, 2826,
      2568, 2796, 3775, 3284, 3742, 3660, 5700, 5145, 2928, 3538, 2214, 2539, 2946,
      2813, 1178, 2352, 2588, 1706, 1758, 2509, 2118, 2104, 2459, 2560, 2153, 2238,
      2055, 1706, 2062, 2209, 3669, 2106, 1950, 2146, 1281, 1942, 2279, 1788, 1773,
      1745, 2056, 2040, 1871, 2195, 1807,
    ],
    '6.6.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10966,
      56520, 30376, 23375, 26294, 21188, 22554, 18877, 13369, 10738, 10666, 10436,
      10265, 5904, 8217, 7377, 7624, 6495, 7303, 6057, 5647, 5356, 5754, 3511, 1631,
      3297, 5425, 5106, 5390, 5300, 5003, 4463, 4375, 4558, 4770, 4641, 4466, 3379,
      4754, 4791, 3763, 3756, 3389, 3420, 2646, 3414, 3366, 2717, 2956, 7748, 3338,
      3218, 2966, 2630, 2988, 3229, 3245, 3474, 3753, 2653, 2803, 2882, 5393, 5253,
      2740, 3037, 2869, 2998, 2489, 2204, 1458, 4256, 2725, 2060, 1931, 2195, 2742,
      2611, 2966, 3082, 2228, 3162, 3083, 3270, 3247, 2679, 2842, 2568, 3846, 3585,
      3545, 4061, 4734, 4375, 6896, 7511, 6551, 4094, 3539, 3375, 2618,
    ],
    '6.20.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17418, 64992, 73465, 79203,
      36202, 33272, 29074, 23810, 22340, 21090, 22971, 21331, 26233, 21172, 21443,
      19492, 18150, 17984, 17678, 16141, 17069, 14308, 14099, 13394, 14466, 7025,
      15351, 13973, 11423, 12228, 16220, 15616, 16216, 13159, 11066, 11267, 13916,
      15018, 13996, 10408, 9443, 8892, 8823, 7133, 6936, 7178, 6586, 6410, 5814,
      5465, 5444, 5461, 5118, 7635, 6295, 6995,
    ],
    '6.2.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8730, 38951, 22227, 20500,
      15812, 11899, 10350, 7769, 7656, 7742, 7707, 6599, 6279, 6686, 6365, 5560,
      5236, 5983, 5176, 5419, 2671, 4652, 4354, 3941, 2998, 2959, 3073, 2755, 2620,
      2075, 1690, 824, 1272, 2052, 1777, 1894, 2508, 2020, 1643, 1716, 2055, 1611,
      1446, 1265, 1025, 1151, 1078, 1447, 1152, 1304, 1316, 6630, 1289, 1653, 1333,
      1106, 2170, 1352, 1368, 1014, 1092, 1127, 1260, 1198, 1222, 1119, 1118, 1045,
      1121, 1913, 1614, 1122, 1116, 770, 1108, 1674, 1151, 464, 969, 766, 600, 790,
      803, 905, 954, 792, 709, 581, 852, 900, 666, 620, 541, 658, 611, 557, 566, 751,
      656, 623, 746, 635, 659, 690, 513, 599, 641, 518,
    ],
    '6.19.9': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 13242, 69136, 21729, 10983, 11489, 9523, 9037, 9181,
      7928, 6541, 6160, 5880, 6273, 6053, 5144, 4354, 4341, 4595, 5501, 5279, 4807,
      4292, 3612, 3369, 3162, 2948, 3444, 2967, 2325, 2611, 2187, 2605, 1087, 2409,
      2694, 1997, 1944, 2280, 2757, 2310, 2497, 2027, 1944, 2710, 2929, 2499, 2848,
      2020, 1782, 1862, 1692, 1752, 2017, 1806, 1840, 2012, 2193, 2199, 2394, 1644,
      2613, 2285, 2990,
    ],
    '7.23.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30391, 19587, 20994, 18877, 16829,
      26521, 31177, 30282, 26558, 29322, 34302, 26447, 13488, 12728, 11665, 10362,
      8310, 9690, 8425, 8669, 9763, 9199, 9905, 9213, 8838, 8680, 8612, 8446, 8882,
      8266, 7458, 7946,
    ],
    '7.5.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9624, 59704, 21349, 14617, 10781, 9139,
      9808, 7055, 6596, 6540, 4778, 3947, 3900, 3895, 3754, 3592, 3790, 3624, 3437,
      3361, 3053, 2717, 2721, 2901, 2676, 2629, 2705, 2545, 1264, 2222, 2316, 2144,
      2089, 2463, 2407, 2221, 2172, 2197, 1737, 2428, 2509, 2158, 2234, 1967, 1869,
      1916, 1946, 2183, 1767, 1665, 1694, 2460, 1760, 1983, 2466, 2333, 2098, 1833,
      2732,
    ],
    '7.17.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 13968, 18804, 18388, 14937, 16499, 14879, 14706, 11635, 12185, 10288,
      11343, 9967, 8478, 4972, 9108, 12424, 9818, 10589, 12267, 12189, 11050, 11408,
      11360, 9611, 10154, 8921, 8091, 7935, 7167, 7878, 7530, 7379, 8196, 8639, 8673,
      8036, 8108, 7609, 7569, 8770, 6988, 7700, 7442, 7469,
    ],
    '6.20.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14181, 80174,
      89978, 105129, 109254, 109236, 119841, 125502, 135250, 127416, 140270, 139297,
      137316, 142801, 151693, 125245, 147575, 149355, 136659, 74092, 137741, 149124,
      123180, 133099, 194016, 172500, 165553, 170033, 174814, 147126, 175046, 175113,
      168223, 170282, 161008, 164102, 158190, 183898, 182906, 185038, 180685, 185377,
      188329, 190441, 189585, 198546, 186526, 190054, 188460, 187851,
    ],
    '7.0.0-beta.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      160, 316, 40, 26, 13, 50, 21, 33, 17, 19, 13, 41, 12, 7, 23, 15, 17, 17, 13,
      15, 18, 18, 17, 15, 15, 18, 23, 18, 19, 4, 6, 3, 1, 2, 6, 1, 1, 0, 2, 0, 1, 0,
      1, 1, 0, 0, 1, 0, 1, 0, 1, 0, 2, 2, 0, 1, 1, 0, 2, 0, 0, 1, 0, 0, 6, 3, 2, 9,
      35, 7, 20, 9,
    ],
    '5.17.16': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      24186, 67594, 15905, 17744, 18427, 16472, 13937, 14175, 11079, 11895, 11560,
      10642, 10345, 9570, 6103, 6065, 6869, 7185, 7132, 6275, 6613, 6003, 5720, 5875,
      4931, 5289, 5288, 5141, 4731, 6222, 7255, 6566, 6336, 5074, 5358, 5121, 3482,
      3295, 3896, 3956, 3766, 4374, 4325, 3640, 3611, 3707, 2115, 1531, 2250, 3145,
      3078, 3332, 9924, 3670, 3278, 3866, 7988, 3098, 2951, 3748, 2606, 2915, 2466,
      2721, 2431, 2311, 2307, 6173, 3772, 3380, 3807, 3550, 5058, 4462, 5283, 5062,
      4969, 4851, 5231, 3930, 5691, 6247, 4935, 4200, 3752, 5305, 5429, 3936, 6000,
      6105, 5509, 6695, 5054, 3310, 5883, 5661, 4169, 4596, 6522, 6016, 4042, 5007,
      5356, 4302, 5844, 4758, 4174, 4386, 4433, 4881, 3977, 4294, 3976, 3506, 4635,
      5313, 4781, 5862, 5917, 5166, 5271, 5834, 5482, 1458,
    ],
    '5.17.19': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 48697, 13348, 10826, 8736, 7303, 6561, 6827, 6376, 5798, 4887,
      4273, 4788, 4811, 3862, 4333, 4293, 4783, 4150, 3699, 3575, 4189, 4136, 3945,
      3659, 3992, 3907, 3022, 3860, 3572, 3363, 3373, 1615, 2421, 2278, 2238, 2056,
      2074, 2158, 1844, 1741, 1748, 1115, 584, 944, 1967, 2176, 1772, 7111, 2024,
      1877, 1707, 5481, 2674, 2103, 2810, 2778, 1988, 2439, 1618, 1495, 1598, 1699,
      3921, 1597, 1563, 1378, 1634, 1540, 1420, 1307, 1015, 1007, 880, 846, 821, 855,
      757, 701, 578, 645, 1594, 1512, 922, 1144, 1254, 1527, 1258, 1568, 296, 908,
      1089, 1137, 815, 799, 916, 980, 875, 999, 977, 1399, 1727, 1823, 999, 1283,
      1456, 1351, 2142, 1010, 1479, 977, 1310, 1109, 1124, 1127, 1138, 627, 1138,
      1154, 1157,
    ],
    '7.29.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 19173, 67460, 16486, 12992, 10943, 8874, 8745, 8004, 6525, 5970,
      5908, 5858, 5564, 4802, 4884, 6053,
    ],
    '5.17.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14726, 58894, 26497, 25547,
      21320, 19061, 13535, 15447, 13755, 9675, 7081, 3722, 7305, 8202, 6683, 7559,
      7121, 6069, 5584, 5997, 4980, 5208, 4762, 3279, 3652, 3695, 4020, 4033, 3006,
      3225, 3302, 3415, 2732, 3401, 3667, 3881, 3630, 2841, 3242, 3663, 3951, 3628,
      4316, 4178, 3814, 2561, 3837, 3596, 3380, 3191, 3860, 3453, 7675, 4459, 4792,
      2235, 919, 1739, 3281, 2694, 3299, 5548, 2572, 6514, 6707, 9296, 5005, 3096,
      3730, 2850, 2464, 2955, 3705, 3154, 2474, 3880, 4131, 2429, 2298, 2336, 2009,
      2098, 2118, 1981, 1590, 1637, 1988, 1886, 1607, 1591, 1684, 1639, 1362, 1535,
      14305, 8525, 1247, 1036, 908, 919, 803, 753, 299, 756, 782, 526, 657, 1160,
      893, 972, 821, 991, 765, 965, 903, 785, 930, 670, 837, 728, 989, 1120, 976,
      973, 785, 763, 807, 811, 843, 794, 726, 911, 927,
    ],
    '7.0.0-alpha.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 366, 517, 225, 514,
      688, 570, 353, 479, 343, 170, 507, 84, 69, 34, 20, 30, 9, 33, 17, 11, 16, 13,
      19, 21, 19, 31, 27, 37, 21, 24, 21, 27, 20, 23, 37, 30, 4, 10, 10, 9, 7, 9, 13,
      8, 0, 5, 12, 23, 0, 12, 5, 3, 5, 16, 12, 5, 1, 7, 1, 1, 4, 5, 1, 15, 4, 11, 15,
      17, 12, 2, 6, 7, 17, 17, 14, 5, 0, 32, 11,
    ],
    '6.12.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 9512, 9514, 12149, 10809, 10908, 11259, 11137, 9935,
      9093, 8769, 9187, 4801, 2109, 3983, 7010, 6324, 6573, 6516, 6803, 7420, 8039,
      7576, 8260, 8132, 8079, 5950, 6781, 5534, 7105, 6678, 5165, 5032, 5175, 4852,
      5329, 5228, 5416, 5243, 5099, 6511, 7623, 6808, 6126, 6401, 5945, 6564, 5032,
      6265, 6729, 5431, 8334, 7757, 6361, 7726, 7439, 6079, 5793, 5667, 2150, 5453,
      5098, 4829, 4209, 4895, 8033, 8160, 10217, 9531, 6559, 7860, 5126, 5793, 6682,
      6085, 14766, 7454, 7570, 8911, 10655, 20054, 29937, 38964, 32709, 32363, 18936,
      32223, 40385, 25096, 24385,
    ],
    '6.0.0-alpha.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 91, 298, 11, 9, 8, 9, 7, 5, 5, 3, 4,
      3, 5, 2, 2, 3, 6, 8, 4, 9, 5, 7, 1, 1, 5, 10, 6, 5, 3, 1, 2, 6, 7, 4, 2, 6, 1,
      1, 1, 2, 4, 4, 3, 3, 4, 1, 3, 0, 2, 0, 305, 12, 2, 1, 2, 2, 2, 1, 1, 2, 1, 11,
      18, 17, 8, 11, 10, 7, 11, 5, 7, 14, 8, 5, 7, 9, 7, 9, 11, 16, 14, 14, 15, 13,
      18, 18, 16, 15, 14, 16, 19, 19, 14, 15, 2, 0, 1, 3, 3, 1, 1, 0, 0, 0, 0, 0, 0,
      0, 0, 1, 0, 0, 0, 0, 0, 2, 1, 0, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 2, 2, 1, 2,
      1, 20, 7,
    ],
    '6.0.0-beta.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 121, 189, 58, 7, 21, 16, 4, 10, 3, 4, 7, 7, 10, 6, 4, 2, 6, 2,
      3, 1, 1, 1, 4, 3, 4, 3, 3, 4, 2, 3, 0, 5, 0, 7, 12, 2, 1, 2, 2, 2, 1, 2, 2, 1,
      13, 17, 17, 49, 11, 11, 7, 24, 5, 7, 12, 25, 5, 8, 10, 8, 6, 14, 14, 14, 14,
      14, 13, 18, 18, 16, 15, 14, 15, 17, 28, 23, 6, 19, 10, 10, 6, 15, 11, 6, 1, 1,
      0, 2, 0, 1, 5, 0, 0, 1, 1, 0, 2, 4, 1, 9, 0, 0, 2, 9, 5, 7, 8, 12, 3, 0, 2, 7,
      7, 7, 6, 5, 9, 26, 16,
    ],
    '6.18.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 112970,
      143511, 73356, 59368, 51672, 43914, 41386, 39934, 34492, 34382, 33724, 28465,
      35654, 34986, 31036, 23000, 23498, 23666, 23758, 21967, 18369, 19527, 22754,
      17724, 16215, 16425, 18757, 15364, 15343, 16067, 13262, 14712, 12229, 13736,
      12969, 13299, 13927, 13430, 16571, 12416, 9520, 10821, 12461, 12089, 5661,
      11008, 12280, 8406, 8701, 11999, 12858, 13555, 12690, 11986, 9825, 10502,
      13387, 12220, 10052, 15454, 7621, 8880, 9755, 12331, 11976, 11311, 11125,
      12556, 9920, 9882, 9028, 9389, 9057, 9869, 10445,
    ],
    '5.13.1': [
      0, 0, 0, 0, 21877, 41985, 21525, 15229, 12919, 13914, 19070, 19145, 16809,
      18088, 18226, 16286, 18878, 17128, 20344, 15785, 14429, 14947, 17176, 12186,
      16474, 20408, 13739, 11858, 2110, 12432, 17854, 14360, 18781, 18324, 18526,
      18497, 18953, 12781, 12370, 11835, 8548, 4192, 3175, 3300, 2736, 1724, 2255,
      2109, 2511, 2443, 2493, 2621, 2661, 2594, 2584, 2526, 1948, 1696, 2257, 1501,
      1772, 1997, 1560, 2099, 17998, 2190, 2386, 2387, 2032, 4715, 1555, 1399, 884,
      491, 839, 1590, 1562, 1617, 9627, 1434, 1528, 2005, 9450, 2123, 1888, 2056,
      1488, 1863, 2176, 2167, 1345, 1011, 941, 2569, 2423, 1428, 3881, 4335, 4722,
      4364, 4442, 2996, 935, 768, 952, 931, 1242, 3978, 1063, 972, 1233, 7836, 4191,
      1128, 1077, 819, 829, 665, 764, 308, 609, 858, 1112, 938, 1071, 944, 1471,
      1313, 1284, 896, 1447, 1181, 1190, 974, 737, 1008, 930, 1094, 1286, 1148, 964,
      1076, 919, 802, 804, 1151, 1324, 663, 460, 774,
    ],
    '7.22.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27986, 113597, 49676, 32222, 26997, 11699, 21200,
      19477, 16659, 18059, 19881, 18683, 18219, 19280, 18163, 12956, 16621, 15198,
      17715, 17661, 16061, 17477, 15120, 16098, 17407, 15808, 12275, 12780, 14872,
      12420, 12342, 13810, 15544, 15288, 14541, 11468,
    ],
    '7.20.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 11438, 92483, 36255, 22259, 20314, 18865, 19239, 14763, 15250,
      14720, 14214, 6316, 10902, 10251, 7309, 6707, 8812, 11055, 9762, 7209, 7126,
      5348, 5833, 5869, 6237, 6017, 5328, 5025, 4199, 4588, 5152, 5089, 3942, 4512,
      5109, 4605, 4617, 4677, 4378, 4566, 4597, 4193,
    ],
    '8.0.0-beta.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 134, 322, 49, 31, 37, 5, 6, 7, 17, 11, 25, 13, 28, 28, 24, 15, 11, 32, 15,
    ],
    '6.9.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 2659, 54999, 20708, 16494, 12753, 10496, 8707, 8052, 7470, 3718, 5581, 7599,
      5602, 4713, 4636, 4367, 3935, 3531, 3542, 2640, 1779, 2579, 3150, 3159, 2958,
      2781, 3042, 2569, 2726, 2610, 2345, 2515, 2327, 2041, 1813, 1998, 2112, 1512,
      1568, 1549, 1680, 1477, 1695, 1437, 1457, 4148, 1263, 1400, 1262, 1165, 1305,
      1373, 1401, 1607, 1675, 1212, 1007, 1076, 2987, 2703, 2060, 1246, 1033, 1370,
      1123, 1231, 564, 1109, 1196, 967, 815, 988, 951, 835, 971, 778, 780, 876, 1095,
      823, 1024, 894, 880, 501, 718, 608, 594, 566, 563, 514, 539, 553, 618, 922,
      650, 719, 748,
    ],
    '5.0.0-beta.4': [
      992, 1219, 1043, 820, 653, 558, 808, 660, 761, 757, 752, 676, 558, 597, 596,
      598, 727, 521, 550, 444, 760, 642, 712, 680, 1816, 415, 484, 320, 228, 390,
      326, 373, 315, 826, 288, 271, 703, 205, 228, 241, 1559, 203, 217, 178, 241,
      148, 194, 143, 177, 813, 151, 212, 164, 110, 157, 152, 222, 195, 254, 241, 219,
      146, 105, 223, 768, 170, 157, 162, 233, 811, 169, 209, 103, 53, 101, 254, 167,
      223, 908, 208, 245, 170, 1195, 213, 242, 218, 191, 182, 189, 163, 143, 202,
      135, 1143, 183, 149, 154, 153, 306, 280, 315, 235, 185, 132, 102, 185, 165,
      267, 179, 155, 66, 2108, 580, 36, 56, 36, 86, 95, 62, 29, 179, 124, 89, 35, 94,
      83, 29, 42, 34, 8, 32, 16, 30, 18, 8, 14, 13, 17, 29, 16, 21, 16, 25, 18, 17,
      34, 19, 21, 94, 32,
    ],
    '5.17.10': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12472, 61108,
      25097, 18840, 18707, 15366, 11873, 10452, 5405, 8428, 10908, 10041, 9583,
      10331, 9741, 8459, 8071, 8721, 9078, 8409, 7493, 7102, 9085, 11270, 8705, 6934,
      7360, 8421, 7453, 6586, 6948, 6695, 6352, 6067, 4210, 4160, 4510, 3751, 3669,
      4027, 3604, 3120, 1780, 3232, 3169, 3093, 2984, 3784, 2896, 6426, 2661, 2432,
      1151, 642, 1310, 1560, 1631, 1971, 6353, 1946, 1645, 1852, 5860, 2134, 1923,
      2018, 1697, 2299, 2374, 2622, 2185, 2411, 2217, 6432, 2249, 2446, 2360, 2257,
      2549, 1874, 2359, 2327, 2005, 2138, 2083, 2195, 2036, 2163, 2229, 2056, 2075,
      3403, 3031, 2056, 2406, 2384, 2280, 2269, 2293, 1050, 2008, 2121, 1698, 1780,
      2240, 1956, 1908, 2202, 1821, 1675, 2106, 1568, 1844, 2088, 1717, 1705, 1418,
      1610, 1457, 1545, 1337, 1488, 1195, 1350, 1318, 1156, 1406, 1266, 1209, 1212,
    ],
    '6.19.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 3071, 127841, 164259, 162828, 80306, 74967, 69782, 64680, 44873,
      47391, 42724, 39975, 37430, 34708, 30167, 30555, 25050, 25850, 25801, 23417,
      21285, 21226, 22226, 18998, 22204, 18000, 20321, 19118, 17902, 16614, 16695,
      16116, 17724, 15268, 15710, 15811, 15049, 6734, 13541, 15007, 11687, 10878,
      12633, 13158, 12101, 12605, 12227, 9730, 13279, 13133, 13894, 28222, 28927,
      26256, 20241, 27616, 26567, 22009, 20234, 21269, 20626, 21320, 21297, 22437,
      23360, 21154, 20128, 22699,
    ],
    '5.17.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7427, 7394, 2954, 2193, 1531, 1232, 1313,
      1170, 1191, 772, 807, 609, 633, 709, 641, 588, 575, 390, 339, 559, 396, 482,
      459, 447, 451, 306, 452, 221, 220, 202, 153, 433, 366, 232, 341, 462, 425, 378,
      282, 318, 331, 356, 449, 429, 339, 377, 308, 246, 354, 478, 501, 257, 598,
      1893, 408, 266, 403, 503, 532, 294, 204, 101, 94, 200, 593, 402, 394, 620, 440,
      378, 561, 710, 529, 406, 428, 373, 471, 348, 424, 567, 482, 487, 658, 296, 382,
      394, 460, 572, 421, 283, 291, 342, 486, 482, 1004, 832, 717, 686, 399, 342,
      1317, 933, 724, 497, 468, 397, 645, 671, 270, 402, 543, 382, 627, 834, 554,
      570, 564, 445, 499, 634, 362, 375, 337, 224, 312, 230, 296, 383, 325, 540, 391,
      379, 296, 273, 324, 284, 313, 374, 425,
    ],
    '7.29.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 37376, 97150, 108682, 47964, 46913, 40710, 36907, 36688,
      36430, 33065, 33559, 31498, 29785,
    ],
    '6.0.0-alpha.14': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 261, 988, 1032, 1051, 1025, 1153, 1334, 1119, 791, 1024, 1036, 782,
      868, 737, 711, 149, 34, 36, 25, 36, 20, 6, 17, 44, 19, 9, 18, 15, 3, 19, 5, 8,
      11, 10, 7, 19, 36, 21, 4, 15, 28, 23, 4, 25, 15, 24, 20, 25, 19, 558, 20, 12,
      41, 610, 7, 17, 16, 10, 8, 14, 10, 27, 14, 20, 24, 20, 18, 20, 25, 27, 18, 19,
      20, 16, 15, 19, 24, 15, 4, 2, 48, 1, 35, 30, 20, 1, 3, 36, 18, 6, 0, 7, 4, 2,
      2, 4, 27, 32, 24, 49, 25, 25, 60, 2, 55, 0, 27, 5, 27, 19, 68, 35, 66, 53, 43,
      45, 11, 77, 1230, 631, 197,
    ],
    '7.23.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9222, 107859, 33860, 22765, 9606, 14428,
      14385, 10695, 10201, 13693, 13240, 11772, 10719, 9719, 7737, 9313, 11030, 8866,
      8300, 7652, 6229, 7773, 7008, 6697, 6211, 5979, 5909, 5688, 4988, 5013, 4835,
      4695, 4781, 5689, 4948,
    ],
    '7.0.0-alpha.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 123, 455,
      255, 139, 132, 197, 184, 126, 205, 139, 182, 23, 9, 19, 22, 23, 20, 32, 25, 21,
      20, 24, 16, 30, 27, 43, 20, 15, 15, 17, 16, 13, 1, 2, 3, 1, 2, 2, 2, 1, 0, 2,
      2, 3, 1, 34, 7, 6, 4, 9, 24, 46, 24, 22, 20, 37, 14, 4, 4, 16, 8, 8, 0, 7, 18,
      13, 31, 20, 10, 19, 16, 38, 15, 31, 14,
    ],
    '8.0.0-alpha.9': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 187, 247, 500, 392,
      400, 334, 271, 279, 228, 186, 251, 373, 175, 156, 167, 220, 294, 272, 220, 193,
      158, 151, 123, 133, 165, 484, 168,
    ],
    '7.28.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 12825, 125807, 52707, 32506, 28770, 30182, 29588, 34163, 27721, 25968,
      19401, 16395, 13410, 13248, 12667, 15689, 11828, 11059, 11072,
    ],
    '5.17.17': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 3359, 41310, 56741, 30926, 24941, 25213, 22983, 19818, 15908, 17339, 17734,
      15218, 16747, 11500, 12703, 12506, 13738, 12885, 10932, 11887, 12478, 12800,
      9534, 11483, 12282, 10714, 10523, 8193, 10534, 11521, 11509, 10599, 11267,
      10160, 10370, 5190, 8543, 7633, 6983, 6361, 6126, 5711, 5825, 5717, 6808, 4202,
      1816, 2961, 5857, 6232, 6706, 16861, 6819, 6509, 5881, 13374, 6511, 6063, 6704,
      7455, 8454, 7832, 7755, 7945, 8152, 8015, 13007, 10449, 9338, 6414, 7610, 6457,
      7972, 8778, 8255, 2527, 1602, 1733, 1735, 1781, 2190, 1851, 2040, 1803, 4499,
      4003, 1746, 1943, 1826, 1972, 1770, 1980, 859, 1810, 1944, 1700, 1481, 1723,
      1611, 2181, 2040, 2214, 1397, 1918, 2287, 1958, 2305, 1419, 1115, 1002, 1244,
      1193, 1311, 1337, 1285, 1464, 1374, 1376, 1586, 1907, 1642, 1849, 1703,
    ],
    '8.1.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 12684, 34407, 12513, 10102, 8923, 7978, 7765, 8186, 7934, 8005,
      8416, 7887, 6930, 6553, 5572,
    ],
    '8.0.0-alpha.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 171, 249, 246, 59, 31, 64,
      38, 162, 103, 12, 29, 39, 40, 35, 14, 3, 29, 19, 32, 56, 57, 58, 133, 133, 53,
      95, 93, 108, 54,
    ],
    '6.0.0-alpha.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 270, 454, 2, 4,
      4, 1, 1, 1, 2, 2, 1, 0, 2, 3, 1, 1, 2, 3, 1, 3, 3, 3, 1, 1, 2, 2, 5, 3, 3, 9,
      1, 1, 2, 5, 5, 3, 6, 4, 4, 3, 2, 2, 0, 7, 12, 2, 1, 5, 2, 2, 1, 1, 2, 1, 11,
      18, 17, 5, 11, 10, 7, 11, 5, 7, 10, 8, 5, 8, 11, 7, 9, 12, 14, 14, 14, 14, 13,
      18, 17, 16, 15, 14, 15, 17, 18, 13, 4, 2, 0, 1, 2, 3, 1, 1, 0, 1, 3, 1, 0, 0,
      0, 1, 0, 2, 0, 0, 1, 1, 1, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 2, 2, 1, 0,
      0, 21, 8,
    ],
    '8.0.0-alpha.11': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 90, 220, 115, 51,
      61, 7, 34, 20, 26, 19, 18, 15, 16, 39, 10, 17, 24, 11, 13, 22, 22, 13, 12, 5,
      25, 33,
    ],
    '7.3.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21690, 17988, 13062, 11445, 9472, 9849,
      10114, 8751, 10313, 10645, 12153, 11224, 10654, 9403, 8671, 9133, 11438, 8225,
      8746, 8402, 11122, 11511, 10373, 8001, 7565, 7055, 7614, 7025, 6795, 2473,
      7425, 6857, 5412, 5905, 9085, 8641, 7463, 7058, 8122, 5657, 7431, 9114, 8313,
      9391, 8288, 7219, 6477, 6066, 5382, 3979, 3131, 2928, 3056, 3644, 3612, 4172,
      4740, 4083, 4146, 5093,
    ],
    '7.7.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10710, 75093, 31710,
      23297, 18224, 13654, 12964, 12696, 12559, 10812, 11101, 7755, 10094, 9626,
      7941, 8646, 7815, 7237, 8607, 5886, 8078, 6349, 8193, 3113, 6868, 6217, 6144,
      7330, 7387, 7123, 5449, 8811, 8597, 6905, 9332, 8975, 7867, 8236, 7563, 7493,
      7043, 6770, 8024, 5514, 8025, 9610, 7468, 6018, 5997, 6606, 5752, 6980, 8242,
      14927,
    ],
    '7.0.0-alpha.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 23, 10, 20, 9, 6, 6, 22, 25,
      27, 8, 15, 10, 10, 10, 5, 7, 10, 8, 5, 7, 9, 7, 6, 11, 14, 14, 15, 13, 13, 18,
      17, 17, 15, 14, 15, 16, 17, 13, 1, 1, 1, 1, 4, 4, 1, 1, 0, 0, 0, 1, 0, 0, 0, 0,
      1, 0, 0, 0, 0, 0, 1, 1, 0, 0, 3, 0, 0, 2, 1, 0, 1, 0, 0, 1, 2, 2, 1, 2, 0, 20,
      8,
    ],
    '5.0.0-beta.5': [
      741, 1129, 1243, 1344, 1965, 1549, 1686, 861, 1084, 1403, 1679, 1255, 1140,
      1506, 1430, 1035, 933, 882, 778, 934, 1314, 852, 1068, 755, 1827, 1266, 1112,
      914, 481, 908, 1188, 841, 823, 1411, 1109, 715, 1313, 757, 913, 1255, 1739,
      677, 557, 917, 739, 937, 946, 1145, 920, 1177, 666, 346, 633, 590, 366, 640,
      774, 529, 672, 603, 705, 863, 252, 739, 1761, 483, 440, 489, 787, 1093, 529,
      474, 301, 193, 285, 467, 436, 327, 1011, 471, 553, 586, 1517, 243, 128, 329,
      413, 326, 162, 282, 438, 356, 366, 1236, 245, 185, 212, 192, 728, 489, 433,
      771, 711, 278, 259, 221, 544, 418, 194, 165, 194, 4530, 1087, 349, 290, 253,
      336, 162, 431, 131, 397, 461, 485, 201, 390, 235, 194, 150, 205, 257, 312, 245,
      234, 367, 223, 280, 263, 331, 396, 343, 289, 254, 491, 270, 266, 412, 194, 192,
      251, 241,
    ],
    '6.13.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 36258, 24319, 18578, 15898, 14260, 13090, 10963,
      7175, 6929, 8499, 4335, 1754, 3920, 8304, 7033, 6189, 6099, 6264, 5730, 5483,
      5362, 5094, 4905, 4395, 3468, 2935, 3424, 2969, 2175, 2613, 2621, 2128, 2233,
      2255, 2193, 2255, 2234, 2483, 1807, 2176, 1962, 2136, 2044, 2228, 2590, 3098,
      2199, 2307, 2168, 6862, 6206, 2029, 2276, 2140, 2198, 2491, 1506, 2091, 2422,
      1563, 1243, 1315, 1658, 1664, 1605, 1807, 1744, 1785, 2030, 2061, 1976, 2002,
      1887, 2322, 2275, 2168, 2392, 2279, 2263, 3157, 2574, 2454, 2459, 2112, 1491,
      1738, 1820, 1731,
    ],
    '6.18.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44159, 81126, 30321, 11077,
      5849, 9106, 14279, 13964, 12582, 13039, 12808, 12269, 11798, 11683, 11092,
      10763, 10656, 9099, 8165, 8465, 9856, 7752, 9238, 9202, 7898, 8307, 5947, 5844,
      6134, 4135, 5570, 4768, 4326, 3863, 4158, 3998, 3519, 3696, 4123, 4184, 3995,
      4094, 4268, 3783, 3628, 3458, 2791, 2693, 3033, 3482, 1663, 3148, 2699, 2593,
      2581, 2976, 3221, 2868, 2854, 3105, 2237, 3640, 3092, 2752, 2222, 2348, 2117,
      1956, 2323, 2594, 2581, 2139, 2383, 2376, 1964, 1949, 2466, 2558, 3011, 2148,
      1955,
    ],
    '8.0.0-alpha.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 116, 189, 7, 0, 1, 1, 1, 0, 1, 1, 0, 0, 2, 0,
      0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1, 1, 2, 2, 2, 1, 1, 20, 8,
    ],
    '5.2.2': [
      5363, 4698, 4557, 4213, 4264, 3327, 3977, 4212, 4051, 3966, 3259, 2769, 3981,
      4741, 4907, 4809, 5155, 4703, 5162, 5769, 5527, 6879, 5874, 6298, 6265, 5856,
      6201, 5967, 3657, 4804, 5412, 5039, 5225, 10713, 5071, 4728, 6590, 2742, 2822,
      3214, 8800, 2067, 2182, 2617, 1879, 2022, 2243, 2557, 2600, 5239, 2203, 2174,
      2378, 2226, 1760, 1763, 2208, 1893, 2514, 2029, 1830, 2477, 1161, 1843, 5745,
      991, 1101, 1227, 999, 2052, 1126, 807, 607, 242, 490, 834, 772, 741, 7980,
      1002, 767, 570, 8310, 819, 868, 841, 657, 783, 871, 817, 534, 574, 531, 5630,
      607, 866, 606, 535, 1847, 851, 810, 350, 323, 461, 459, 440, 427, 1156, 579,
      651, 587, 3453, 2018, 498, 449, 729, 425, 499, 478, 390, 209, 284, 295, 279,
      464, 290, 322, 453, 558, 407, 415, 446, 625, 454, 336, 316, 296, 537, 607,
      1467, 949, 1101, 689, 1446, 1468, 2000, 779, 761, 687, 559,
    ],
    '7.0.0-beta.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 159, 565, 509, 110, 12, 9, 5, 7, 9, 7, 7, 12, 14, 14, 14, 13, 13, 18,
      17, 16, 16, 14, 15, 16, 16, 18, 1, 2, 1, 1, 3, 3, 1, 4, 0, 0, 0, 2, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 2, 2, 2, 2, 1, 20,
      9,
    ],
    '6.0.0-alpha.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 212, 496, 47, 149, 125,
      85, 20, 21, 6, 7, 9, 9, 12, 17, 5, 3, 7, 6, 6, 3, 15, 18, 3, 3, 8, 6, 5, 7, 7,
      5, 14, 3, 2, 1, 4, 1, 9, 5, 5, 5, 8, 3, 9, 3, 2, 0, 7, 16, 7, 6, 5, 8, 3, 3, 3,
      4, 1, 14, 20, 19, 6, 12, 13, 7, 13, 7, 9, 12, 8, 8, 7, 9, 7, 6, 11, 14, 14, 19,
      24, 15, 22, 17, 18, 15, 37, 41, 17, 19, 15, 4, 3, 1, 2, 57, 35, 1, 1, 0, 0, 1,
      5, 1, 1, 1, 0, 0, 1, 0, 0, 0, 3, 0, 1, 0, 0, 1, 1, 0, 2, 0, 1, 1, 0, 0, 1, 2,
      2, 1, 1, 0, 22, 8,
    ],
    '5.17.26': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9552, 64052, 85070, 96220, 82504, 99453, 117820,
      127282, 128035, 123941, 139837, 131280, 139650, 133548, 141717, 141019, 139187,
      139453, 132748, 143230, 141759, 141441, 142014, 141504, 138275, 152403, 96043,
      164448, 152121, 149682, 148634, 159417, 151978, 153407, 150157, 155395, 94546,
      49540, 97243, 147044, 146937, 148950, 150723, 146703, 134656, 143153, 148231,
      147481, 146333, 142085, 124551, 137225, 137472, 131118, 131805, 144782, 138896,
      216588, 140777, 141287, 141541, 137647, 153061, 145181, 141268, 134768, 129825,
      132521, 132262, 128805, 140072, 132688, 135133, 131941, 134695, 190589, 181497,
      133075, 145754, 123672, 131188, 136301, 128295, 66346, 125072, 128075, 101284,
      107071, 131520, 140852, 126141, 133518, 124314, 99068, 125651, 130756, 126107,
      128863, 117965, 120309, 115524, 132864, 130132, 137208, 135917, 132854, 126622,
      127093, 126691, 136434, 128811, 140224, 139466, 132200,
    ],
    '5.17.13': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10347,
      60434, 21443, 17173, 12836, 8581, 11886, 13123, 11792, 11145, 11663, 11099,
      9356, 10568, 10717, 9183, 8822, 7907, 9816, 9559, 10390, 8144, 5621, 7727,
      9303, 8798, 7081, 8506, 8920, 8236, 6987, 7845, 4928, 6016, 6204, 3885, 3897,
      3250, 2465, 1760, 2590, 2167, 2503, 2290, 2567, 1953, 15714, 2093, 1964, 1427,
      848, 1297, 1971, 2322, 2168, 7020, 2276, 2058, 2284, 6957, 2521, 2621, 2505,
      2476, 2182, 1445, 1694, 1596, 1718, 1831, 5914, 1679, 1680, 1740, 2031, 3334,
      1985, 1820, 1969, 2274, 2276, 2210, 2012, 2007, 1795, 1629, 1821, 1937, 2591,
      2155, 1539, 1663, 1608, 1559, 1573, 1400, 702, 1406, 1487, 1036, 1211, 1706,
      1521, 1618, 1450, 1044, 1027, 1045, 1426, 1197, 1074, 1368, 1596, 1305, 1321,
      1863, 2085, 1838, 2271, 2428, 3106, 3343, 3893, 3709, 4656, 3967, 2753,
    ],
    '6.3.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9116, 43277, 20636,
      17073, 16479, 16376, 13702, 14086, 14154, 10602, 11883, 10732, 11550, 12555,
      11111, 11729, 12075, 6171, 9749, 8595, 8131, 8083, 9114, 8151, 7816, 6779,
      6199, 4112, 2988, 3780, 5491, 6627, 5488, 6305, 5778, 4561, 4911, 3878, 3659,
      4157, 4486, 3893, 4738, 4374, 4346, 3217, 2807, 3544, 13535, 3635, 3254, 3795,
      3173, 4978, 2617, 3076, 2337, 2400, 3031, 2913, 3500, 3237, 2963, 2536, 2606,
      2363, 6756, 6172, 2854, 2851, 2880, 2697, 3120, 3331, 697, 1665, 2269, 1559,
      1817, 2320, 2493, 1868, 2044, 2093, 1779, 3291, 4235, 1904, 2553, 1935, 1680,
      2155, 2629, 2912, 2299, 2372, 2101, 2293, 2714, 2665, 2748, 2027, 1983, 1893,
      2006,
    ],
    '7.0.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 4587, 32430, 23295, 11619, 9248, 7297, 6175, 6345, 6794,
      8727, 5136, 4823, 4401, 4083, 3851, 4473, 3564, 3107, 3582, 3801, 3807, 3307,
      4294, 3898, 3522, 4341, 3828, 3684, 4146, 3894, 3919, 3310, 2833, 4047, 1213,
      2559, 3058, 2650, 2580, 3018, 4042, 3771, 2525, 4363, 2903, 3488, 3842, 3182,
      3265, 2324, 2148, 2630, 3138, 1847, 2203, 2756, 2503, 1571, 2906, 2937, 1820,
      2490, 2319, 2457, 2388,
    ],
    '5.17.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7885, 54119, 23790, 17759, 14012, 13170,
      10372, 8861, 8444, 7959, 7365, 7593, 7439, 7264, 5466, 3013, 5410, 7271, 6076,
      5537, 6085, 6338, 5340, 5492, 4924, 4868, 4807, 3348, 3608, 3741, 4384, 3974,
      3709, 3793, 3618, 3153, 2882, 3107, 3351, 3157, 2935, 2713, 3394, 3319, 3120,
      2671, 2390, 2119, 2436, 1787, 2558, 25798, 2574, 2433, 2671, 2583, 3785, 2090,
      1849, 1469, 739, 1528, 1976, 2222, 1827, 4129, 1644, 1354, 1865, 4287, 1653,
      1793, 1570, 1589, 1530, 1382, 1399, 1271, 1145, 1268, 2956, 1388, 1252, 1094,
      1110, 1732, 1445, 1304, 1347, 1184, 1252, 1531, 1486, 1602, 4904, 1232, 1264,
      1507, 6583, 4431, 1282, 1416, 1380, 1646, 1654, 1576, 543, 1160, 1337, 1140,
      1091, 1447, 1683, 1931, 1758, 1538, 1363, 1754, 1852, 1770, 1629, 1372, 1870,
      1393, 1314, 1133, 1958, 1740, 1844, 1756, 1807, 1804, 2210, 1439, 1402, 1551,
      1909,
    ],
    '7.27.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 113758,
      103685, 53230, 37049, 39134, 40071, 30744, 25645, 23592, 35300, 35775, 22241,
      18945, 16577, 14832, 14830, 13046, 15557, 15463, 14269, 12506, 13007, 12795,
      15119,
    ],
    '6.20.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5862, 53517, 70492,
      70698, 30502, 29905, 27538, 27200, 19992, 19830, 14307, 14498, 14373, 15061,
      15722, 14742, 13308, 12652, 10328, 11804, 11584, 10834, 6924, 11002, 10877,
      7364, 6618, 7666, 7369, 7703, 8019, 6598, 4268, 4929, 5173, 5991, 5561, 5308,
      5173, 5411, 5511, 5927, 5687, 5348, 5205, 4699, 4573, 4645, 4374, 4624, 4229,
      4214, 4417,
    ],
    '5.0.0-beta.3': [
      384, 406, 350, 425, 372, 384, 462, 370, 313, 323, 293, 360, 316, 269, 297, 309,
      363, 432, 525, 403, 470, 403, 378, 322, 1099, 473, 433, 362, 160, 205, 335,
      389, 483, 735, 402, 383, 397, 284, 256, 204, 639, 272, 239, 258, 330, 117, 181,
      165, 229, 396, 256, 173, 166, 219, 254, 193, 135, 208, 215, 251, 204, 208, 85,
      125, 476, 156, 184, 140, 115, 721, 249, 229, 105, 53, 42, 105, 80, 115, 631,
      136, 109, 123, 389, 114, 82, 51, 65, 56, 121, 165, 89, 146, 76, 453, 67, 88,
      76, 87, 262, 104, 83, 149, 54, 29, 29, 72, 33, 144, 67, 90, 119, 1808, 431,
      238, 38, 59, 69, 109, 109, 40, 175, 184, 97, 62, 150, 129, 114, 89, 128, 53,
      63, 66, 69, 103, 118, 97, 72, 73, 123, 34, 37, 148, 113, 113, 114, 118, 68, 60,
      111, 80,
    ],
    '6.17.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15621, 22611, 20745, 19035,
      10167, 5376, 9688, 14834, 13387, 11609, 10870, 11322, 9489, 9545, 10169, 9059,
      8648, 9457, 5948, 7219, 8230, 8955, 6752, 6397, 6219, 6561, 6053, 5255, 5250,
      5994, 3955, 5233, 5735, 3470, 3711, 4435, 4766, 3782, 4727, 3620, 4785, 5373,
      4578, 52806, 43588, 4372, 4260, 3099, 4663, 4862, 5044, 1757, 4738, 4760, 3282,
      3937, 6235, 4817, 5480, 5190, 4887, 3234, 3821, 3956, 4325, 3997, 4390, 4368,
      3866, 4072, 4438, 4542, 4662, 4117, 3966, 4766, 4722, 4530, 3816, 4284, 4551,
      4805,
    ],
    '5.15.0': [
      0, 0, 0, 0, 0, 0, 6896, 45948, 17470, 13890, 12816, 11670, 11542, 9557, 8851,
      7928, 7089, 6818, 6112, 5719, 5051, 5578, 5478, 4426, 4583, 4237, 3902, 3295,
      1644, 3059, 3672, 3877, 3915, 4865, 3937, 3670, 3353, 3567, 3194, 3786, 2923,
      3217, 2561, 2594, 2210, 1854, 1898, 1873, 1850, 1707, 1859, 1958, 2081, 1858,
      1606, 1693, 1967, 1481, 3967, 1765, 1447, 1627, 722, 1156, 8925, 1340, 1195,
      1276, 1143, 2104, 1060, 1073, 731, 469, 732, 1119, 1020, 1262, 3332, 1074,
      1209, 1226, 2761, 1106, 1041, 1487, 1135, 1426, 1235, 1338, 1135, 1166, 1065,
      2173, 837, 870, 751, 857, 1288, 929, 882, 756, 761, 769, 810, 758, 894, 1969,
      825, 836, 730, 3386, 2284, 727, 799, 771, 874, 798, 1058, 437, 886, 864, 762,
      802, 1055, 1178, 913, 724, 761, 578, 697, 788, 596, 765, 646, 616, 543, 570,
      591, 813, 675, 768, 1362, 2008, 2384, 2221, 863, 508, 632, 615,
    ],
    '6.11.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 22341, 78257, 16984, 24546, 21767, 20632, 18107, 17955,
      13754, 8675, 8742, 8154, 5524, 2718, 5550, 7080, 6232, 7137, 7113, 7172, 5551,
      5370, 5505, 5372, 5535, 5502, 4048, 4535, 4762, 4936, 4078, 5493, 4863, 4112,
      4509, 4431, 4004, 3696, 3585, 3423, 3887, 3510, 3054, 3991, 3429, 3827, 3492,
      4019, 3183, 3313, 3440, 9251, 8723, 2746, 2455, 2470, 2713, 2292, 2036, 976,
      2644, 2398, 2104, 2208, 2938, 2764, 2533, 2326, 2484, 2084, 2111, 2430, 1639,
      1655, 1322, 1263, 1095, 2994, 2759, 2476, 2702, 1942, 1242, 1033, 1014, 1245,
      1060, 1445, 1915, 1603,
    ],
    '8.0.0-alpha.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 96, 168, 8, 80, 23, 8, 20, 13, 3, 2, 1, 11, 1, 0,
      0, 1, 1, 0, 0, 2, 0, 0, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 4, 0, 20, 9,
    ],
    '5.14.0': [
      0, 0, 0, 0, 0, 4113, 48933, 21001, 16634, 12674, 10626, 9675, 8412, 8959, 8013,
      8077, 7345, 7842, 7014, 5671, 5977, 6474, 7230, 6474, 5416, 5786, 5232, 4363,
      2695, 3670, 5197, 5310, 4336, 4787, 5017, 4178, 4244, 4168, 4349, 4541, 3435,
      3973, 4593, 4163, 4068, 3369, 3343, 3756, 3690, 3599, 3393, 3286, 3425, 4599,
      3017, 5256, 4398, 4761, 3911, 3165, 3129, 3536, 2304, 3304, 11600, 3469, 2627,
      2871, 3754, 4214, 3083, 3193, 2031, 863, 1291, 2333, 2332, 2584, 5079, 2862,
      2343, 2275, 4368, 2373, 2621, 2149, 1779, 2107, 1928, 1661, 1843, 1265, 1308,
      3228, 1996, 1981, 1147, 1276, 1880, 1307, 1430, 920, 1022, 1296, 1162, 1403,
      1339, 2649, 1017, 1295, 1197, 4986, 3769, 1249, 1132, 1410, 1402, 1434, 1191,
      601, 1238, 1058, 989, 965, 1843, 1620, 1430, 1196, 1377, 907, 1148, 1656, 1274,
      870, 909, 1017, 845, 1145, 1010, 1093, 1069, 816, 1002, 845, 848, 824, 936,
      756, 815, 757,
    ],
    '5.7.0': [
      12658, 11294, 11272, 9751, 9049, 7271, 8421, 7096, 6646, 6827, 6587, 5478,
      4919, 5359, 4984, 5120, 4727, 4639, 4636, 4566, 4437, 4682, 4960, 4363, 4833,
      5046, 4614, 3996, 2526, 3547, 5109, 4809, 4191, 5078, 6026, 5551, 6790, 6006,
      6378, 5720, 40976, 4432, 4522, 5070, 5303, 5215, 5615, 5722, 5869, 11851, 5337,
      4783, 4945, 4673, 4357, 4311, 4281, 4078, 4394, 4341, 4351, 4183, 1364, 2246,
      7200, 1973, 2163, 2007, 1910, 2263, 1393, 1408, 1380, 926, 953, 1451, 1542,
      1345, 3500, 1949, 1432, 1360, 4473, 1567, 1197, 2725, 1856, 4080, 3845, 4864,
      1208, 1417, 2508, 16533, 4501, 4073, 4868, 4302, 7208, 3798, 1561, 4409, 3356,
      1868, 1728, 1723, 1670, 1852, 1108, 954, 1441, 6000, 4645, 3739, 3258, 3671,
      3679, 3085, 3939, 2341, 2982, 3167, 3019, 2618, 965, 1148, 1184, 1813, 1074,
      909, 1062, 1521, 2478, 2457, 2088, 3098, 2969, 2953, 2311, 1360, 1258, 1903,
      1589, 3684, 4232, 4197, 2261, 2010, 1927, 1434,
    ],
    '7.0.0-beta.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 124, 358, 123, 31, 9, 20, 20, 18, 17, 11, 21, 26, 19, 21, 22, 23,
      23, 28, 28, 18, 23, 25, 23, 18, 63, 35, 24, 13, 19, 15, 19, 5, 22, 6, 1, 8, 3,
      16, 4, 13, 1, 2, 9, 11, 3, 12, 7, 4, 13, 18, 12, 14, 0, 11, 40, 24, 35, 24, 61,
      32, 42, 49, 51, 54, 15, 11, 31, 24,
    ],
    '8.0.0-alpha.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 210, 34, 13, 10, 2, 1, 1, 1, 0, 1, 0,
      0, 1, 1, 1, 1, 2, 0, 0, 1, 0, 1, 1, 0, 1, 1, 2, 2, 2, 3, 0, 20, 8,
    ],
    '7.29.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 18284, 75438, 28067, 17128, 14985, 13698, 11451, 11112,
      11103, 10234, 9714, 9992, 9123, 7547,
    ],
    '7.0.0-beta.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 119, 3753, 2032, 330, 113, 78, 75, 69, 75, 65, 84, 72, 60, 54,
      57, 61, 63, 47, 29, 36, 50, 28, 35, 38, 2, 26, 23, 32, 42, 35, 54, 40, 0, 0,
      18, 46, 4, 0, 7, 2, 1, 2, 0, 0, 1, 1, 0, 1, 1, 3, 2, 0, 0, 3, 1, 3, 3, 1, 0, 1,
      2, 2, 3, 1, 2, 21, 13,
    ],
    '7.29.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10217, 83286, 106855, 109636, 118981, 65291,
      49039, 37687, 33563,
    ],
    '7.23.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26739, 116825, 35009, 10206, 16602, 15221,
      11315, 11686, 16661, 18521, 17728, 25085, 23963, 19948, 13785, 13106, 13097,
      28664, 32547, 28377, 20109, 29943, 29491, 22820, 22415, 25451, 23163, 21920,
      21734, 23747, 24701, 23076, 19464, 25080,
    ],
    '5.12.0': [
      23355, 22227, 18648, 16089, 13926, 11314, 12453, 11256, 10124, 9914, 9241,
      8186, 8939, 8059, 8548, 8618, 7924, 7801, 8051, 7872, 6769, 7029, 7545, 6295,
      7664, 8109, 8390, 7260, 3989, 5972, 6864, 6766, 6773, 7699, 6729, 6070, 5707,
      6156, 6558, 5767, 4256, 4602, 5410, 5408, 5752, 5401, 4948, 4469, 5622, 6052,
      4924, 4496, 5424, 4541, 4467, 4118, 3500, 4154, 4538, 4425, 3138, 3878, 2312,
      3715, 13203, 4968, 4542, 4023, 4383, 4462, 2490, 2812, 1710, 812, 1468, 2936,
      2715, 2774, 6436, 2564, 2318, 2680, 4882, 2436, 2296, 2627, 1914, 2470, 2647,
      3140, 1991, 2443, 2686, 6917, 2446, 2295, 1467, 1719, 5779, 1838, 1770, 1679,
      1862, 2082, 1943, 1407, 1679, 2705, 1568, 1771, 1930, 6281, 4644, 1974, 1395,
      1625, 1819, 1548, 1681, 585, 1641, 1834, 1484, 1405, 1593, 1453, 1375, 1460,
      1511, 1176, 1720, 1560, 1531, 1571, 1390, 2175, 1228, 1565, 1749, 1630, 1362,
      1401, 1445, 1609, 1597, 2272, 1397, 1481, 1562, 1467,
    ],
    '5.1.0': [
      1906, 2050, 2144, 2074, 1799, 1168, 1229, 1091, 1182, 1334, 2115, 1740, 2032,
      2061, 1639, 1556, 1892, 2057, 2151, 1846, 1870, 2110, 1940, 1504, 1454, 1286,
      1221, 1150, 509, 969, 1598, 1435, 1306, 2801, 1354, 1141, 2024, 1423, 2077,
      916, 2869, 240, 350, 313, 386, 358, 270, 923, 1965, 1850, 1810, 1103, 1498,
      938, 1132, 1698, 1154, 1184, 1651, 1147, 1091, 1215, 891, 1120, 2649, 1160,
      990, 1183, 1244, 2005, 816, 1077, 615, 183, 565, 904, 734, 861, 2540, 1070,
      603, 1243, 2615, 819, 626, 842, 455, 696, 1350, 851, 975, 851, 956, 3218, 1056,
      944, 627, 987, 1151, 532, 647, 826, 455, 596, 482, 634, 594, 894, 451, 841,
      528, 1749, 1285, 680, 603, 800, 1119, 760, 799, 223, 556, 524, 560, 680, 853,
      730, 732, 690, 376, 252, 579, 351, 684, 792, 393, 600, 848, 444, 360, 493, 380,
      988, 600, 1030, 1032, 826, 887, 439, 564, 392,
    ],
    '8.0.0-beta.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      94, 237, 45, 169, 50, 1, 1, 1, 2, 1, 0, 1, 1, 2, 2, 1, 2, 0, 20, 8,
    ],
    '6.0.0-alpha.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 56, 534, 57, 20, 2, 6,
      11, 0, 1, 5, 5, 5, 5, 0, 2, 4, 1, 1, 1, 3, 1, 2, 3, 3, 1, 2, 3, 4, 11, 3, 3, 6,
      4, 6, 2, 3, 6, 3, 6, 11, 4, 3, 0, 6, 0, 11, 17, 9, 8, 6, 5, 7, 5, 4, 2, 9, 14,
      21, 21, 6, 11, 11, 8, 11, 14, 8, 14, 16, 8, 8, 12, 9, 12, 12, 16, 15, 23, 18,
      16, 24, 19, 19, 16, 15, 15, 19, 19, 15, 12, 6, 6, 2, 71, 64, 4, 4, 2, 6, 5, 3,
      4, 3, 2, 8, 8, 0, 0, 0, 1, 1, 4, 1, 0, 0, 0, 0, 1, 2, 0, 0, 1, 1, 3, 2, 2, 2,
      1, 0, 0, 21, 7,
    ],
    '5.2.1': [
      4153, 4483, 4080, 3789, 3469, 3007, 3413, 3181, 2964, 2784, 3133, 3595, 3387,
      3682, 3014, 3270, 3280, 3322, 3174, 2862, 2584, 2801, 3258, 3074, 3139, 3075,
      2449, 2274, 1696, 2206, 3480, 3432, 4786, 7172, 4801, 4900, 6455, 4507, 4673,
      5156, 10316, 4143, 3814, 5417, 4735, 4304, 5190, 6511, 4183, 3598, 1221, 1320,
      1562, 1372, 1362, 1529, 1434, 1227, 1430, 1059, 1168, 1146, 761, 1319, 4164,
      1073, 1128, 1182, 1104, 1971, 1237, 1441, 958, 509, 816, 1267, 1561, 927, 5925,
      1302, 1161, 1014, 6599, 1113, 1356, 1401, 974, 1032, 705, 704, 646, 669, 941,
      4282, 698, 885, 984, 848, 1491, 594, 768, 755, 695, 869, 778, 1266, 675, 1519,
      901, 740, 1125, 2791, 2049, 1169, 820, 1378, 1327, 1350, 947, 305, 751, 1159,
      715, 1009, 1277, 796, 1266, 946, 1116, 917, 811, 828, 760, 1022, 647, 419, 575,
      566, 468, 414, 546, 470, 536, 930, 911, 586, 293, 288, 460, 379,
    ],
    '7.23.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 73873, 123183, 67376, 38251,
      36212, 35629, 33147, 29401, 26128, 25891, 19280, 21945, 22831, 22241, 20652,
      18958, 19571, 19703, 20020, 17460, 17789, 19700, 17450, 17275, 17657, 17522,
      18909, 18339, 17311, 16184, 16944,
    ],
    '6.0.0-alpha.11': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 101,
      669, 967, 804, 924, 372, 133, 88, 41, 20, 85, 79, 92, 52, 113, 87, 146, 20, 36,
      1, 2, 2, 5, 3, 3, 2, 2, 1, 5, 2, 4, 4, 3, 4, 2, 3, 0, 5, 0, 7, 13, 3, 28, 23,
      2, 2, 1, 1, 2, 1, 11, 18, 16, 22, 11, 16, 7, 33, 5, 13, 23, 12, 6, 9, 12, 7, 6,
      11, 14, 14, 14, 14, 14, 19, 17, 16, 17, 14, 14, 17, 18, 13, 4, 2, 12, 1, 14,
      15, 4, 1, 1, 6, 5, 11, 0, 0, 1, 0, 0, 0, 3, 8, 4, 7, 6, 4, 9, 1, 10, 12, 19,
      28, 1, 6, 23, 27, 29, 37, 10, 9, 6, 15, 7, 52, 11,
    ],
    '7.1.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 7309, 43846, 21256, 12002, 7821, 8769, 8933, 7065,
      7574, 8208, 7290, 8033, 4779, 7032, 7546, 6275, 5455, 5525, 5357, 4799, 4227,
      4356, 4580, 4715, 4566, 4117, 3988, 4380, 4745, 3691, 4203, 3847, 3474, 1775,
      3520, 3055, 2979, 2803, 12506, 4448, 3474, 3405, 3200, 2789, 3517, 3740, 3365,
      3423, 2945, 3396, 3636, 3819, 3779, 4289, 3390, 2927, 3139, 3073, 3143, 3056,
      2963, 2881, 3983, 3638,
    ],
    '8.3.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 22541, 36248, 16548, 9846, 8025, 6743, 6802, 6714, 6601,
      5863, 5241, 4825, 4213,
    ],
    '6.18.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103429, 61973, 36044, 20398,
      9642, 17571, 27378, 24712, 24103, 21296, 18225, 14549, 16707, 15437, 13035,
      12736, 12191, 9371, 11821, 11041, 11146, 8826, 10089, 8850, 8571, 9719, 10073,
      9239, 8479, 7576, 7710, 6917, 7153, 5844, 7315, 7642, 8265, 8400, 7243, 7848,
      7380, 6795, 5768, 5790, 5805, 6754, 5903, 5348, 5351, 5740, 2781, 5446, 5860,
      5061, 4799, 6176, 6295, 6402, 5746, 5074, 4293, 5400, 5635, 5728, 6119, 5100,
      5579, 4720, 4894, 4895, 4613, 4778, 4780, 4590, 4968, 4939, 5562, 6050, 5852,
      6746, 6344,
    ],
    '6.1.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3558, 28349, 14447, 10344, 8631,
      8942, 8352, 7385, 6325, 6415, 6275, 5558, 4987, 3689, 4531, 4398, 4375, 4387,
      3782, 3532, 3964, 2455, 3966, 3606, 2725, 2425, 2690, 3050, 2473, 2258, 1635,
      1049, 543, 1331, 1763, 1723, 1633, 1696, 1666, 1483, 1282, 1618, 1380, 1307,
      1470, 1468, 1527, 1712, 1457, 1250, 1429, 1385, 5210, 1400, 1233, 1256, 1400,
      1963, 1288, 1456, 1149, 1026, 1062, 1190, 1079, 1055, 1138, 1122, 1131, 892,
      2236, 2126, 1012, 1012, 1118, 912, 841, 674, 377, 659, 655, 591, 453, 674, 658,
      597, 522, 584, 501, 1059, 1297, 1481, 886, 1223, 1446, 1446, 2450, 1859, 1246,
      1172, 1175, 834, 569, 567, 793, 800, 930, 855, 738,
    ],
    '5.0.0-beta.0': [
      5, 10, 10, 17, 9, 23, 3, 3, 9, 6, 9, 7, 19, 16, 8, 548, 8, 9, 8, 12, 30, 20, 5,
      24, 59, 6, 38, 13, 0, 26, 15, 5, 9, 36, 2, 4, 57, 12, 3, 8, 160, 2, 4, 7, 3, 1,
      1, 7, 1, 16, 1, 3, 4, 5, 4, 2, 2, 3, 5, 1, 4, 2, 2, 0, 556, 12, 2, 1, 2, 35, 2,
      2, 1, 3, 2, 4, 5, 3, 32, 3, 3, 3, 48, 1, 2, 2, 0, 3, 2, 0, 0, 0, 0, 26, 0, 0,
      1, 0, 3, 0, 2, 0, 0, 1, 2, 2, 1, 83, 2, 2, 1, 123, 11, 1, 1, 0, 2, 4, 1, 0, 1,
      1, 0, 0, 5, 2, 2, 3, 2, 2, 1, 1, 0, 1, 0, 0, 3, 3, 0, 2, 0, 6, 4, 2, 2, 1, 3,
      2, 20, 4,
    ],
    '7.9.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5648, 66197, 25489,
      11121, 9149, 10873, 10668, 9386, 8980, 6518, 6854, 6377, 6550, 5882, 5760,
      6021, 7134, 5326, 5972, 5109, 5887, 3175, 5034, 5763, 4936, 6541, 4338, 4303,
      3625, 3758, 3360, 2814, 3213, 3221, 3150, 2965, 2693, 2578, 1791, 2324, 2618,
      2551, 2567, 2655, 2354, 2408, 2403, 2331, 2221, 2542, 2442, 2361,
    ],
    '7.0.0-beta.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 167, 256, 153, 112, 109, 92, 43, 14, 20, 56, 26, 20, 12, 19, 21, 14, 17,
      17, 18, 17, 17, 15, 15, 26, 62, 58, 21, 1, 9, 5, 2, 3, 4, 1, 1, 0, 1, 1, 0, 0,
      0, 0, 0, 1, 3, 2, 1, 0, 3, 14, 7, 1, 1, 4, 2, 13, 32, 2, 0, 2, 1, 5, 51, 22,
      22, 39, 22, 34, 39, 9,
    ],
    '7.13.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11040,
      80980, 59748, 26680, 24282, 15557, 13678, 12328, 12047, 13128, 12007, 12726,
      13512, 11863, 11366, 9434, 8967, 4907, 9363, 9273, 8437, 7437, 10373, 8061,
      9191, 7229, 6325, 5350, 7042, 8021, 8131, 8687, 6498, 7140, 6724, 6954, 8046,
      7249, 7312, 6345, 6122, 5457, 5450, 5139, 4545, 4953, 5029, 5222,
    ],
    '5.5.0': [
      3229, 3584, 3504, 2647, 2247, 1993, 2354, 2274, 1931, 1798, 1922, 1765, 1677,
      1852, 1526, 1811, 2059, 2220, 2156, 1865, 1634, 1824, 1476, 1527, 1598, 1388,
      1211, 986, 496, 1199, 1185, 915, 1041, 1034, 978, 861, 2510, 1014, 1094, 1135,
      5219, 1044, 1057, 1039, 1018, 658, 1043, 888, 920, 2678, 1031, 958, 935, 863,
      974, 1199, 1171, 1194, 1245, 973, 1052, 891, 467, 833, 2512, 797, 819, 727,
      673, 1124, 870, 619, 408, 234, 288, 488, 609, 417, 888, 390, 285, 427, 3739,
      358, 361, 406, 442, 375, 469, 574, 567, 416, 396, 3404, 372, 336, 382, 295,
      1262, 283, 212, 251, 232, 252, 281, 232, 352, 533, 374, 257, 233, 1138, 766,
      230, 228, 216, 228, 260, 214, 154, 338, 367, 286, 293, 439, 348, 353, 335, 321,
      227, 295, 371, 362, 306, 309, 258, 219, 261, 384, 485, 559, 829, 1229, 1901,
      2125, 1324, 1016, 726, 822, 394,
    ],
    '7.24.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13798, 90246, 60196, 34984,
      33533, 31036, 26967, 27046, 21647, 22339, 22172, 26267, 23585, 22423, 21816,
      19329, 20377, 18017, 15750, 11588, 12422, 12005, 11962, 12044, 11272, 11194,
      11237, 9782, 11052,
    ],
    '6.18.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19833, 17715, 15062, 7702,
      3785, 7546, 12649, 12156, 12595, 11259, 10485, 11327, 9677, 10357, 9353, 8338,
      8995, 6520, 6255, 6832, 6854, 4659, 4871, 5355, 6024, 4744, 5290, 4894, 6376,
      5778, 5450, 4889, 3908, 2897, 3876, 4849, 3383, 3986, 3658, 3675, 2942, 2741,
      2421, 2394, 2579, 2687, 2341, 2305, 2205, 2012, 805, 2039, 2038, 1504, 1753,
      2002, 2992, 2242, 2562, 3271, 2908, 3605, 3708, 3711, 2601, 2128, 2166, 2150,
      2856, 2762, 3010, 2946, 2788, 2555, 3460, 3506, 3241, 2992, 3086, 1806, 1833,
    ],
    '8.5.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11456, 56510, 22786, 21296, 13512, 12310,
      10952, 10080, 9388,
    ],
    '7.7.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17902, 71843, 33702, 24672,
      22280, 18557, 12570, 12670, 11970, 11751, 10624, 11167, 8237, 8908, 9064, 8588,
      7905, 7387, 6859, 8019, 6649, 6300, 6891, 5615, 2981, 5592, 4890, 4313, 4308,
      6038, 5946, 5640, 5630, 4946, 4182, 5181, 4953, 4493, 5733, 5352, 4794, 4499,
      5581, 5266, 6007, 5947, 6576, 6775, 8428, 8417, 7671, 6629, 6499, 6107, 5520,
    ],
    '6.3.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6132, 41460, 17689,
      12261, 10027, 9162, 7801, 7822, 6735, 6392, 6061, 5977, 5477, 5465, 5019, 5567,
      5194, 5263, 3142, 4462, 3479, 3835, 3361, 4139, 3867, 4100, 3936, 3622, 3426,
      2636, 2978, 4712, 4729, 3723, 5009, 4009, 3389, 3445, 2752, 2815, 2958, 3086,
      2475, 2537, 1921, 2035, 2015, 2000, 2628, 7399, 2478, 1797, 1847, 1861, 2763,
      1925, 2340, 1517, 1321, 1792, 1604, 1723, 1817, 1590, 1404, 1462, 1333, 2970,
      2856, 1165, 1216, 1026, 1226, 1273, 1081, 440, 954, 1186, 1023, 1054, 1316,
      1445, 1301, 1500, 1547, 953, 1379, 1417, 1520, 1513, 1158, 1652, 1209, 1224,
      1247, 1125, 1175, 993, 779, 733, 726, 601, 559, 549, 598, 535,
    ],
    '8.0.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 7589, 29400, 8174, 6875, 6344, 3972, 3362, 4062, 3566, 3538, 3503,
      3901, 3889, 4016, 3946, 3281,
    ],
    '6.0.0-alpha.9': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 107, 409,
      57, 24, 26, 5, 10, 20, 21, 12, 38, 40, 20, 14, 14, 30, 18, 17, 7, 13, 13, 31,
      47, 3, 5, 3, 5, 2, 3, 1, 4, 10, 3, 4, 3, 4, 1, 3, 1, 2, 0, 8, 12, 5, 1, 4, 58,
      4, 3, 1, 2, 1, 14, 18, 16, 17, 11, 12, 11, 22, 9, 9, 14, 7, 5, 7, 9, 9, 8, 11,
      16, 14, 18, 13, 13, 22, 21, 18, 15, 14, 15, 17, 18, 13, 4, 2, 1, 1, 6, 7, 1, 1,
      0, 0, 3, 1, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 0, 0, 0, 0, 2, 1, 0, 2, 0,
      0, 1, 4, 4, 1, 0, 3, 21, 8,
    ],
    '6.18.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 60368, 54321, 47055, 27284,
      14480, 24385, 35823, 31198, 33933, 35970, 30061, 25872, 25816, 26300, 26210,
      26125, 26171, 23084, 22779, 22511, 23291, 19058, 22641, 20890, 19598, 18137,
      18036, 17066, 16236, 15456, 18341, 17579, 14373, 16585, 17942, 17775, 15399,
      17311, 13301, 8153, 8549, 8529, 9096, 8382, 7949, 8579, 7914, 8597, 9292, 8712,
      3568, 7515, 7673, 6433, 6577, 7682, 7073, 6966, 6617, 6429, 5749, 7364, 7465,
      8181, 7106, 6956, 6678, 5316, 8969, 10381, 10511, 8001, 6168, 8000, 7563, 7579,
      6571, 5467, 5496, 5913, 6983,
    ],
    '5.15.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 15597, 57696, 35398, 31213, 26197, 25186, 25669, 23139,
      24516, 21920, 25937, 21533, 20131, 22419, 24066, 16526, 21345, 25239, 18806,
      14030, 3300, 16583, 22071, 18933, 22729, 22467, 22042, 21987, 10457, 8019,
      7460, 7166, 6189, 7478, 7644, 7897, 6509, 8253, 8841, 9795, 9489, 6881, 6929,
      9447, 8354, 7665, 6951, 8462, 7362, 8133, 8978, 8499, 8077, 8718, 4593, 8715,
      30032, 6748, 6794, 6481, 5522, 9283, 4805, 5539, 1940, 743, 2473, 4295, 4191,
      5637, 14531, 4840, 4230, 5540, 11028, 4867, 4400, 4739, 3974, 3599, 4969, 4455,
      4191, 5691, 5213, 8354, 4528, 4024, 3926, 5652, 5025, 4659, 4626, 4382, 4663,
      5634, 5129, 3614, 4636, 6917, 3667, 3856, 4564, 13721, 9346, 3864, 3710, 2633,
      4580, 4737, 4452, 974, 3983, 5141, 4039, 3783, 5169, 5431, 5070, 4678, 4431,
      2918, 3934, 4024, 4338, 5328, 4995, 4676, 4775, 4671, 4703, 4561, 4483, 4060,
      3562, 2898, 2939, 3663, 3108, 2805, 2687, 3677,
    ],
    '5.6.0': [
      3057, 2826, 2997, 2917, 3142, 2405, 2244, 2159, 2641, 2423, 2683, 2448, 2516,
      2453, 2206, 1846, 1982, 1902, 1958, 1728, 1677, 2297, 2330, 1827, 2403, 2217,
      1818, 1993, 547, 1509, 1617, 1578, 2023, 1950, 1862, 2026, 1676, 1856, 2097,
      2466, 8793, 2058, 1142, 1086, 1254, 1131, 775, 977, 720, 1903, 922, 817, 992,
      845, 895, 823, 1104, 682, 925, 811, 688, 690, 509, 855, 2516, 774, 655, 684,
      648, 1009, 552, 538, 495, 484, 514, 758, 809, 813, 1703, 931, 702, 487, 1462,
      436, 537, 514, 285, 285, 214, 312, 185, 163, 250, 2346, 284, 201, 236, 268,
      968, 234, 246, 314, 186, 155, 211, 275, 245, 459, 171, 170, 194, 1170, 720,
      171, 107, 174, 151, 120, 133, 90, 143, 166, 95, 88, 245, 223, 286, 249, 250,
      343, 364, 300, 341, 164, 53, 65, 102, 95, 123, 86, 123, 82, 141, 103, 100, 120,
      176, 166, 190, 96,
    ],
    '6.4.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3708, 44721, 24702,
      18738, 16073, 13325, 12353, 11462, 11338, 12130, 11391, 11855, 9718, 8683,
      8045, 8155, 4475, 6680, 6367, 6908, 6268, 5499, 5323, 6124, 5774, 5019, 3650,
      2089, 3141, 4615, 4623, 4388, 4818, 4628, 4494, 3286, 3226, 3240, 2828, 3521,
      2896, 2969, 3170, 2895, 2417, 2645, 2401, 13514, 2628, 2357, 2438, 2327, 4124,
      2004, 2177, 1834, 1899, 2235, 2220, 2103, 2952, 2441, 1706, 2049, 2069, 4796,
      4916, 1993, 2166, 1809, 1504, 2286, 2016, 661, 1824, 2421, 1806, 1991, 2610,
      2512, 2188, 2470, 3056, 2713, 2926, 2473, 2521, 2870, 2503, 2460, 1964, 1993,
      1269, 1188, 891, 1189, 928, 1711, 1894, 1488, 854, 1047, 1002, 896,
    ],
    '6.19.11': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15330, 99250, 111303, 107935, 58524, 57238,
      51293, 46993, 46404, 38544, 40500, 38155, 35998, 35954, 33209, 34661, 28108,
      29458, 23993, 27577, 24381, 22771, 22893, 21829, 19946, 21745, 17159, 20809,
      18480, 20386, 12118, 18558, 20030, 16220, 17392, 19696, 19319, 16744, 19716,
      20499, 14908, 19361, 19715, 15915, 18008, 17657, 18235, 17363, 19175, 20696,
      17798, 18826, 20137, 17112, 14297, 14326, 15346, 12533, 16228, 14840, 20090,
    ],
    '8.5.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29332, 61814, 26873, 18435, 17889, 15088, 14048,
      11158, 8731, 8736,
    ],
    '7.27.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34306,
      136834, 49416, 34470, 29481, 23239, 20163, 15943, 15023, 12776, 14250, 15167,
      13014, 10388, 10057, 10613, 10830, 10874, 9337, 9330, 9701, 8592, 9054,
    ],
    '6.0.0-alpha.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 173, 367, 20,
      6, 14, 8, 2, 3, 3, 4, 7, 2, 3, 1, 1, 1, 3, 1, 2, 3, 3, 2, 4, 1, 2, 5, 3, 3, 2,
      3, 1, 4, 3, 4, 3, 3, 4, 1, 3, 0, 2, 0, 7, 12, 5, 1, 2, 3, 2, 1, 1, 2, 1, 12,
      18, 16, 5, 11, 10, 7, 11, 5, 7, 10, 8, 5, 7, 9, 7, 7, 11, 14, 14, 14, 14, 13,
      18, 17, 16, 15, 14, 14, 17, 16, 13, 4, 2, 0, 1, 2, 3, 1, 1, 0, 0, 0, 0, 1, 2,
      4, 1, 3, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 3, 1, 2, 0, 0, 2, 0, 0, 1, 2, 2, 1, 0,
      0, 21, 8,
    ],
    '7.2.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1642, 48422, 8496, 8484, 8172, 7792, 6936, 12168,
      9813, 9760, 9079, 11049, 9674, 9416, 9574, 6853, 7541, 8314, 8832, 11767,
      10879, 8361, 9017, 7509, 7289, 6615, 8106, 6623, 7972, 7421, 6747, 3639, 7556,
      6797, 5075, 5392, 7148, 6783, 6058, 5943, 5094, 4441, 6541, 6114, 5811, 5796,
      5514, 5430, 4826, 5411, 5850, 6124, 6021, 6552, 6722, 6244, 6348, 6590, 5741,
      7403, 7211, 8908,
    ],
    '6.9.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 12662, 58067, 24529, 17470, 14346, 12234, 11497, 13959, 7261, 13252,
      10992, 10841, 10311, 10907, 9458, 8772, 8072, 7075, 3935, 1882, 4401, 6702,
      7172, 6621, 6052, 6827, 6509, 6370, 6985, 8441, 6747, 7328, 6332, 7457, 5485,
      6453, 4969, 5961, 5412, 5816, 5625, 4685, 4170, 5228, 5531, 5357, 5602, 4862,
      5079, 5513, 5111, 4872, 4351, 5577, 5258, 5927, 5171, 9366, 9325, 5484, 5151,
      3976, 5868, 4609, 5450, 3637, 5250, 7033, 3301, 1613, 2415, 1903, 2082, 2088,
      1980, 1669, 1816, 1823, 1596, 2021, 1950, 2828, 2556, 3380, 1822, 1467, 1252,
      1306, 1093, 1193, 1198, 1214, 1351, 1437, 1844, 1437,
    ],
    '6.19.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17751,
      109667, 41761, 31939, 24178, 23148, 24840, 20432, 19748, 18413, 14602, 15629,
      14198, 14038, 12707, 12403, 11765, 11766, 12714, 11102, 12429, 12469, 9042,
      10157, 8175, 8062, 7402, 8539, 8455, 6613, 7464, 5654, 6620, 6857, 5829, 6094,
      5678, 5622, 5990, 5532, 5833, 4813, 4226, 2423, 4848, 4699, 3823, 3716, 3632,
      4297, 3468, 4326, 3965, 3465, 4871, 4305, 3788, 3845, 3345, 3182, 2710, 3415,
      3454, 3091, 3115, 2849, 2858, 2875, 2816, 2579, 2696, 2281, 2730, 2851,
    ],
    '5.12.3': [
      0, 6386, 59108, 63023, 35388, 27154, 30754, 28006, 29028, 25240, 27648, 25305,
      21652, 22209, 20211, 18821, 19219, 16942, 18642, 15820, 14974, 13688, 12707,
      10816, 12449, 11124, 10034, 7523, 4505, 7609, 9046, 8014, 7966, 8179, 7886,
      7756, 7580, 7648, 7304, 7428, 6057, 6595, 7348, 7548, 6489, 6479, 7430, 8378,
      8298, 8289, 9113, 8672, 8363, 7527, 6820, 7726, 6171, 5642, 6170, 5125, 4915,
      6669, 3434, 6843, 23875, 5508, 4735, 4669, 4736, 6315, 3415, 3369, 1765, 993,
      1900, 3201, 3447, 4279, 7712, 4205, 3218, 3447, 7166, 3661, 3442, 3737, 3033,
      3107, 3798, 3926, 3495, 4093, 3720, 8601, 3934, 3909, 3030, 3603, 17007, 3378,
      3251, 3314, 3271, 3355, 3141, 2728, 3278, 4981, 2111, 2119, 2059, 9904, 6192,
      1913, 1751, 1791, 1954, 2054, 1847, 1065, 1899, 1682, 1447, 1584, 2138, 1686,
      1848, 2156, 1879, 1730, 2230, 1970, 2003, 1853, 1811, 1965, 1647, 2243, 2529,
      3476, 2377, 2747, 2160, 2318, 2302, 2177, 2288, 2450, 2082, 2196,
    ],
    '5.17.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15269, 61594, 31667,
      24418, 22050, 16616, 19898, 21795, 17376, 12900, 6424, 10328, 12613, 13939,
      13940, 14924, 15092, 14014, 17828, 19804, 15948, 11192, 8248, 9343, 10404,
      11273, 11248, 10431, 10896, 11609, 11003, 7165, 8480, 9968, 7515, 6988, 7495,
      9966, 9068, 9369, 9385, 8751, 7953, 10679, 4914, 8121, 8000, 7009, 7339, 7867,
      7026, 10199, 5933, 5670, 4160, 1868, 4618, 6148, 5497, 5118, 12297, 6028, 6223,
      5879, 12578, 5505, 5272, 5373, 5043, 5080, 5732, 5674, 6294, 6057, 6007, 10487,
      5633, 5896, 4706, 5073, 5120, 4809, 4949, 4512, 5023, 4910, 4783, 5076, 4934,
      5083, 5183, 5627, 5130, 28699, 16351, 5178, 6521, 3900, 4808, 4813, 4421, 2409,
      6834, 4957, 3244, 3208, 4359, 4780, 4435, 4381, 5026, 3432, 4502, 4528, 3954,
      4391, 4934, 3809, 3807, 6870, 7541, 6723, 5854, 3864, 4110, 4581, 4725, 4275,
      3088, 3325, 3374, 3521,
    ],
    '6.14.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21298, 87458, 37232, 29267, 25108, 21121, 16883,
      15429, 15489, 15605, 6544, 2634, 8294, 13866, 13083, 12239, 14750, 12281, 8402,
      9627, 9089, 8859, 8710, 7542, 9783, 6242, 5034, 6235, 4105, 4286, 4062, 4931,
      3853, 4775, 4463, 5421, 5467, 5773, 4671, 5595, 4155, 5359, 6756, 4933, 3670,
      5103, 5179, 6076, 4023, 12340, 11191, 4126, 4385, 2516, 3379, 2956, 2926, 1977,
      3402, 3838, 3436, 3854, 7547, 8933, 9769, 8534, 8423, 6120, 6097, 4816, 5838,
      5422, 5307, 2866, 2798, 1881, 1612, 1006, 1014, 1269, 1358, 1352, 1370, 1773,
      1525, 1051, 1253, 1890,
    ],
    '7.28.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      95857, 50411, 30997, 28071, 25048, 23651, 20845, 22305, 21722, 20243, 19387,
      19846, 18671, 17811, 17609, 18901, 15107, 15644, 14574, 14695,
    ],
    '6.16.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15591, 80895, 33575, 24665, 23972, 11323,
      10967, 9962, 5604, 2844, 4417, 8861, 8221, 7945, 7656, 7678, 6452, 6751, 7534,
      7089, 6269, 6141, 5078, 5307, 5721, 5425, 4926, 4517, 4766, 4748, 5296, 5247,
      4941, 4560, 4143, 3522, 3475, 3171, 3318, 3072, 2979, 3214, 3057, 6836, 3174,
      2952, 3200, 11450, 10339, 3345, 3003, 2897, 2611, 2923, 2381, 1068, 2478, 2594,
      1657, 1797, 2229, 2436, 2236, 2205, 1892, 1779, 2217, 2268, 2000, 2139, 1406,
      1676, 1595, 1762, 2024, 1971, 1442, 1486, 1549, 1744, 1748, 1847, 1788, 1157,
      1151, 1322,
    ],
    '5.0.0': [
      456, 294, 379, 399, 474, 332, 379, 424, 561, 415, 320, 259, 363, 354, 359, 366,
      347, 169, 228, 138, 136, 264, 206, 170, 432, 263, 218, 213, 167, 205, 256, 110,
      80, 350, 117, 125, 195, 254, 133, 90, 447, 117, 73, 68, 65, 71, 89, 78, 60,
      173, 109, 92, 76, 62, 75, 84, 93, 94, 126, 77, 131, 99, 36, 47, 374, 210, 94,
      384, 185, 297, 132, 348, 295, 189, 200, 293, 249, 314, 575, 196, 64, 255, 502,
      187, 230, 200, 202, 230, 195, 244, 311, 372, 396, 726, 324, 265, 206, 57, 203,
      123, 166, 382, 326, 447, 457, 200, 448, 504, 188, 313, 489, 623, 397, 328, 205,
      281, 146, 281, 223, 92, 207, 202, 237, 101, 327, 380, 412, 304, 470, 393, 491,
      405, 411, 488, 249, 294, 272, 185, 293, 522, 414, 393, 366, 492, 492, 435, 561,
      533, 611, 639,
    ],
    '6.0.0-beta.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 300, 511, 528, 426, 404, 288, 307, 302, 382, 315,
      346, 333, 418, 358, 296, 295, 477, 398, 403, 537, 455, 477, 404, 333, 349, 175,
      271, 202, 269, 237, 407, 283, 219, 267, 162, 145, 167, 89, 17, 35, 166, 196,
      172, 131, 225, 154, 161, 456, 187, 109, 127, 113, 107, 74, 97, 75, 80, 77, 263,
      59, 110, 93, 29, 116, 34, 41, 111, 45, 64, 67, 47, 63, 68, 48, 77, 46, 187,
      161, 38, 28, 44, 39, 42, 86, 4, 21, 75, 34, 59, 46, 43, 18, 32, 17, 11, 22, 20,
      13, 6, 5, 6, 18, 14, 19, 17, 3, 0, 1, 7, 7, 1, 1, 2, 20, 10,
    ],
    '6.8.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      6259, 52064, 21056, 15405, 12937, 10715, 9800, 9399, 7840, 7509, 6911, 3936,
      6746, 6576, 6519, 6780, 7085, 6740, 7011, 6144, 4746, 3056, 1449, 3195, 4648,
      4414, 4738, 4831, 3991, 4228, 3985, 4722, 5558, 7817, 8318, 6207, 5950, 6941,
      8326, 7182, 7110, 6588, 7099, 6465, 6424, 6406, 7071, 7730, 5007, 4960, 5116,
      4615, 4488, 4899, 4376, 4213, 5200, 5501, 5314, 5394, 7982, 7194, 5477, 5150,
      4964, 5395, 5825, 5633, 3790, 6040, 6122, 5468, 5238, 6444, 6210, 6251, 5924,
      5921, 5396, 5448, 5530, 5609, 6015, 5839, 5487, 4864, 5809, 6665, 7203, 7274,
      8374, 8637, 9045, 9256, 9139, 8478, 8508, 8421, 8511,
    ],
    '5.0.0-beta.2': [
      1774, 1684, 1544, 1337, 1488, 1319, 1518, 1645, 1352, 929, 1128, 977, 995,
      1093, 899, 4258, 980, 952, 998, 1095, 1342, 1286, 1422, 1379, 2576, 963, 1026,
      591, 625, 553, 582, 543, 322, 1050, 587, 687, 1008, 841, 755, 807, 1737, 160,
      216, 196, 196, 141, 129, 174, 163, 891, 150, 149, 129, 147, 124, 152, 153, 203,
      174, 219, 162, 127, 113, 195, 4394, 201, 127, 144, 135, 1046, 117, 118, 71, 33,
      46, 92, 78, 92, 831, 144, 96, 96, 964, 54, 98, 79, 49, 43, 39, 126, 76, 67, 79,
      1217, 46, 36, 51, 27, 370, 62, 38, 47, 41, 42, 46, 39, 45, 992, 80, 30, 64,
      2347, 518, 41, 57, 62, 61, 56, 29, 16, 56, 55, 61, 39, 91, 88, 159, 151, 100,
      65, 75, 71, 74, 156, 96, 76, 76, 60, 75, 71, 31, 39, 88, 46, 45, 77, 79, 116,
      167, 82,
    ],
    '8.2.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 8706, 40726, 31559, 38675, 40772, 36695, 34445, 30522, 30251,
      40130, 28491, 29630, 24684, 23599,
    ],
    '7.14.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      14832, 63447, 28870, 20559, 10771, 10110, 8896, 9253, 8349, 7879, 7087, 7986,
      6838, 6187, 6187, 6540, 2984, 5148, 5378, 3918, 3985, 4922, 4832, 5173, 4706,
      3964, 3787, 4198, 4250, 4465, 3969, 3709, 3284, 3653, 3539, 3692, 3373, 3357,
      3501, 3158, 3212, 3156, 2681, 2519, 2881, 2885, 2741,
    ],
    '6.0.0-beta.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 596, 426, 365, 424, 447, 247, 124, 175, 334, 304,
      194, 427, 457, 22, 16, 11, 4, 20, 7, 26, 13, 20, 4, 6, 4, 4, 0, 8, 0, 14, 12,
      2, 1, 2, 2, 2, 1, 2, 3, 2, 11, 17, 17, 6, 11, 14, 7, 211, 5, 9, 14, 8, 5, 7, 9,
      7, 6, 10, 25, 14, 15, 14, 13, 19, 17, 16, 16, 14, 14, 17, 18, 13, 5, 2, 3, 1,
      3, 4, 3, 2, 2, 5, 2, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 1, 0, 0, 3, 1, 0, 2,
      1, 1, 11, 0, 4, 2, 3, 3, 1, 0, 0, 20, 8,
    ],
    '6.0.0-beta.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 128, 200, 76, 49, 49, 87, 150, 106, 164, 117, 137, 136,
      127, 118, 108, 95, 180, 160, 72, 54, 132, 37, 115, 59, 168, 148, 44, 88, 40,
      11, 12, 49, 37, 18, 14, 16, 55, 51, 66, 88, 26, 44, 89, 61, 80, 52, 76, 92, 79,
      125, 11, 11, 13, 11, 9, 8, 24, 7, 6, 11, 137, 14, 14, 14, 29, 42, 17, 18, 15,
      15, 14, 17, 19, 17, 5, 2, 3, 1, 12, 13, 1, 1, 4, 3, 2, 0, 0, 0, 0, 0, 0, 1, 1,
      0, 0, 0, 11, 2, 0, 1, 2, 5, 8, 29, 10, 4, 15, 17, 9, 11, 10, 10, 10, 7, 8, 27,
      16,
    ],
    '6.5.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7181, 56092,
      67056, 37542, 29697, 25858, 23012, 18357, 20395, 21115, 20859, 19052, 17030,
      16704, 16076, 9247, 14393, 14281, 15092, 14377, 16926, 18460, 12413, 12467,
      13492, 7574, 2959, 7216, 12827, 10928, 12552, 12430, 10580, 9771, 8789, 9093,
      9435, 9023, 8837, 7273, 7684, 7727, 8610, 9564, 7634, 7734, 52002, 7390, 6903,
      7095, 7152, 9104, 6645, 5569, 6096, 5045, 5881, 6302, 4965, 6058, 6210, 7453,
      6493, 7272, 14576, 13619, 7858, 8270, 6687, 5899, 6165, 5819, 2805, 5823, 5488,
      4705, 5648, 5971, 5850, 5499, 5625, 6324, 5177, 5308, 5643, 5576, 5219, 5019,
      5268, 4732, 5590, 5369, 4705, 4610, 4555, 4426, 4723, 4708, 5026, 4219, 4914,
      5029, 4261,
    ],
    '6.16.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9881, 94746, 19165, 17581, 15831,
      9441, 4779, 8343, 10980, 10147, 10228, 11208, 9540, 9121, 8797, 8156, 7196,
      7069, 6803, 5896, 5998, 5924, 5490, 10676, 9749, 8040, 4868, 4150, 4146, 4289,
      4385, 3669, 3902, 3920, 5116, 3529, 3546, 4448, 3757, 3723, 3186, 5019, 3461,
      4685, 23906, 19768, 3048, 3120, 2668, 2768, 2943, 3831, 1400, 2814, 3460, 2407,
      2447, 3357, 2745, 2617, 2632, 3806, 4130, 3695, 3041, 3054, 2664, 3575, 3942,
      3160, 2571, 2577, 2271, 2118, 2086, 1957, 1725, 1730, 2071, 1886, 2109, 2102,
      2158,
    ],
    '5.15.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 10585, 51790, 23607, 19481, 19079, 17263, 15291,
      14565, 14086, 13265, 11597, 12139, 11692, 11967, 9429, 11889, 8301, 8376, 6896,
      4277, 5580, 6707, 6422, 6876, 7438, 8502, 5809, 6915, 6369, 6881, 7251, 4900,
      5399, 4975, 5531, 5771, 6010, 5742, 6182, 6608, 5671, 5413, 5973, 5814, 4885,
      3708, 3747, 5066, 4813, 4003, 3925, 4136, 4467, 2516, 4154, 18995, 4200, 3151,
      3570, 3303, 4721, 3026, 2980, 1362, 745, 1121, 2317, 2561, 2565, 5553, 2478,
      3094, 2737, 5856, 2837, 2614, 2624, 2840, 3019, 3214, 3358, 2789, 3719, 2865,
      5825, 3584, 5501, 3542, 4750, 3689, 4434, 5543, 3612, 3660, 3502, 2927, 2832,
      3262, 5669, 2926, 2840, 2235, 8030, 6272, 2152, 2285, 1569, 1762, 2600, 2128,
      1250, 2548, 2547, 1824, 1508, 1448, 1710, 1797, 1184, 1330, 1117, 1540, 1700,
      1620, 1499, 1243, 1540, 1331, 2238, 1940, 1311, 1185, 1289, 1181, 1489, 1494,
      1236, 832, 813, 898, 774,
    ],
    '8.0.0-alpha.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 300, 246, 182, 103, 149, 181,
      126, 86, 154, 47, 78, 64, 135, 59, 7, 10, 3, 5, 2, 9, 8, 2, 8, 4, 4, 2, 10, 6,
      21, 17,
    ],
    '7.22.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 118726, 142871, 65084, 50873, 42815, 35571, 16214,
      34637, 30192, 24207, 24519, 31419, 28599, 27630, 27537, 26025, 21675, 22854,
      23047, 21772, 20552, 19477, 18984, 18079, 17925, 17914, 18306, 16552, 16253,
      15108, 14904, 15108, 15509, 14500, 15920, 13563, 16024,
    ],
    '6.11.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 13973, 70386, 31256, 23185, 11050, 13254, 11513, 11774,
      11038, 11250, 10633, 7254, 6690, 6603, 7410, 3783, 4655, 6003, 5800, 5902,
      5939, 5397, 5092, 5166, 4821, 4894, 4511, 4522, 3801, 4266, 4273, 4486, 4738,
      4103, 4179, 4067, 3710, 3437, 3493, 3985, 3110, 2737, 3299, 2919, 2903, 3599,
      2183, 2466, 2423, 2182, 2742, 2685, 2718, 7921, 6819, 2692, 2466, 2560, 2461,
      2288, 2439, 1360, 2340, 3173, 1745, 1608, 2169, 2012, 2675, 2807, 1997, 1636,
      1838, 2471, 2067, 2137, 2063, 2793, 1632, 2480, 2626, 2896, 3878, 3207, 4739,
      5039, 4930, 5605, 3913, 7068, 5075, 4618,
    ],
    '5.0.1': [
      2426, 1959, 2023, 1861, 1973, 1555, 1559, 1464, 1415, 1143, 1242, 1166, 1154,
      1370, 1173, 1500, 1389, 1965, 1596, 1603, 1761, 1451, 1163, 1083, 11685, 875,
      915, 781, 517, 695, 809, 692, 635, 2268, 637, 783, 1780, 786, 679, 773, 3551,
      484, 558, 620, 765, 508, 770, 979, 4259, 5976, 4270, 5823, 5339, 7166, 6579,
      6159, 6806, 4634, 7009, 6723, 3746, 6019, 3500, 8050, 8624, 8755, 6149, 7900,
      5905, 5283, 862, 1156, 601, 187, 506, 917, 787, 948, 2843, 1092, 979, 958,
      3377, 976, 1057, 992, 868, 939, 891, 840, 922, 1105, 692, 5326, 799, 828, 836,
      740, 2339, 753, 581, 373, 451, 354, 410, 427, 390, 813, 445, 431, 602, 3450,
      3154, 3168, 571, 1526, 2429, 511, 405, 246, 356, 395, 266, 321, 574, 376, 387,
      303, 351, 244, 391, 337, 372, 338, 316, 343, 277, 316, 269, 228, 274, 253, 561,
      529, 541, 593, 1095, 2331, 376, 238,
    ],
    '5.9.0': [
      9143, 9474, 10091, 8903, 9996, 8311, 9308, 9311, 9809, 9630, 9829, 9481, 8386,
      8066, 7789, 7570, 7950, 7206, 7682, 8231, 7842, 7980, 8019, 7023, 6955, 7286,
      8307, 8332, 6790, 7547, 7433, 7811, 7032, 7015, 8237, 7063, 7427, 7750, 8184,
      7986, 7022, 8730, 9164, 8679, 9261, 8473, 7971, 8635, 9619, 13869, 12892,
      10326, 9928, 9210, 8631, 8471, 8491, 8678, 8382, 8095, 7160, 7002, 4589, 6898,
      15589, 7501, 6616, 8241, 8012, 7572, 6432, 5455, 4372, 3157, 4190, 5032, 4806,
      4756, 7706, 5237, 5105, 4829, 8422, 4499, 4963, 4855, 4791, 5143, 5720, 5273,
      5459, 5403, 5125, 17999, 5973, 5432, 5182, 5453, 7988, 4785, 4291, 4036, 4207,
      4260, 4391, 4307, 4309, 6644, 4513, 4483, 4647, 13223, 9356, 5076, 4971, 4990,
      4530, 4750, 4784, 3863, 4863, 3758, 2637, 2397, 2959, 2879, 2745, 2727, 2675,
      2234, 1993, 1806, 1677, 1849, 982, 610, 602, 671, 656, 689, 511, 514, 728, 752,
      738, 700, 619, 649, 867, 586,
    ],
    '7.0.0-alpha.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 167, 221, 23, 11, 50, 93,
      131, 113, 117, 87, 68, 74, 66, 59, 53, 77, 61, 60, 61, 46, 47, 65, 67, 103, 56,
      63, 60, 59, 59, 34, 35, 45, 38, 41, 61, 45, 24, 18, 14, 11, 15, 15, 9, 15, 6,
      3, 5, 0, 0, 6, 11, 14, 4, 10, 1, 4, 0, 4, 11, 9, 6, 15, 23, 5, 0, 20, 2, 6, 0,
      1, 14, 0, 1, 2, 2, 1, 2, 7, 20, 8,
    ],
    '5.10.0': [
      29562, 27319, 27513, 22663, 22576, 19045, 22352, 23603, 21696, 20523, 19955,
      17724, 16996, 18221, 17166, 17206, 17939, 16023, 16687, 16691, 15726, 16553,
      15797, 12311, 14120, 13718, 12704, 11077, 6129, 10105, 14455, 12906, 13575,
      14698, 12842, 12044, 12572, 10930, 13298, 12420, 9581, 12502, 12338, 10452,
      13539, 10582, 11445, 10867, 11042, 23944, 10490, 8104, 8076, 7642, 7014, 7970,
      7572, 6815, 7370, 6380, 6288, 6252, 3919, 5724, 22566, 5892, 5426, 5862, 5614,
      7908, 4822, 4693, 3425, 1786, 3284, 5016, 4919, 4824, 10840, 4886, 4793, 5406,
      11142, 7796, 6231, 5071, 4603, 5363, 4104, 4531, 5285, 4780, 4798, 30406, 4061,
      4372, 4402, 4630, 10457, 3472, 3698, 4353, 4224, 4488, 4537, 4404, 5627, 6645,
      3926, 4223, 4378, 12760, 8906, 3128, 3411, 2378, 3038, 3012, 2647, 1389, 2673,
      2835, 2384, 2826, 4255, 3803, 3819, 4009, 3828, 2741, 3717, 3996, 3200, 3700,
      4054, 3415, 3578, 3071, 3587, 3679, 3595, 4325, 4010, 3901, 3907, 3912, 3926,
      3755, 2538, 2631,
    ],
    '7.6.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19609, 77521, 29839, 20232,
      15239, 14346, 12719, 10056, 8618, 8863, 9117, 7722, 8799, 7473, 7303, 6494,
      5316, 4324, 4307, 4250, 4438, 4116, 3724, 3955, 3987, 1959, 3470, 3395, 2743,
      2691, 3931, 3414, 3449, 3199, 3072, 2257, 3085, 3154, 2737, 2917, 2430, 3423,
      3456, 2878, 3159, 2725, 2288, 2566, 2287, 2393, 2366, 2349, 2050, 2301, 2370,
      2246,
    ],
    '5.0.0-beta.6': [
      1016, 880, 767, 666, 932, 701, 678, 833, 665, 627, 704, 792, 662, 654, 269,
      386, 521, 393, 399, 340, 1228, 311, 612, 344, 1600, 568, 527, 456, 268, 416,
      712, 458, 528, 788, 570, 392, 773, 436, 398, 431, 1159, 285, 289, 360, 265,
      313, 306, 335, 295, 479, 246, 240, 217, 184, 175, 298, 202, 336, 220, 275, 220,
      246, 129, 311, 652, 204, 202, 169, 171, 856, 225, 194, 105, 94, 134, 243, 463,
      288, 708, 280, 241, 276, 1058, 226, 267, 182, 163, 213, 209, 140, 402, 383,
      381, 934, 434, 386, 377, 349, 418, 261, 239, 160, 237, 255, 274, 272, 375, 334,
      272, 240, 270, 2098, 1768, 318, 275, 195, 252, 259, 265, 129, 333, 301, 195,
      144, 263, 234, 200, 373, 310, 193, 155, 184, 174, 93, 83, 98, 131, 81, 143, 82,
      109, 103, 136, 108, 108, 71, 95, 65, 65, 52,
    ],
    '7.0.0-beta.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149,
      154, 21, 13, 9, 19, 11, 11, 16, 20, 14, 16, 13, 8, 6, 12, 14, 14, 14, 14, 13,
      18, 17, 17, 16, 15, 15, 16, 17, 13, 2, 2, 5, 2, 4, 5, 1, 1, 0, 0, 2, 0, 1, 0,
      2, 1, 1, 0, 0, 0, 0, 1, 1, 2, 2, 0, 1, 0, 0, 3, 3, 0, 2, 1, 1, 1, 3, 3, 1, 2,
      1, 20, 9,
    ],
    '6.0.0-alpha.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 105, 500, 13, 3, 5, 7, 3, 6, 2, 2,
      1, 0, 0, 2, 2, 1, 1, 1, 1, 3, 2, 1, 2, 2, 2, 3, 3, 3, 4, 1, 1, 2, 6, 2, 3, 2,
      1, 1, 0, 4, 5, 3, 8, 5, 2, 3, 0, 2, 0, 105, 13, 2, 1, 2, 2, 2, 3, 1, 2, 1, 12,
      19, 16, 5, 12, 10, 7, 11, 5, 7, 31, 22, 5, 7, 9, 8, 6, 11, 15, 14, 15, 13, 13,
      18, 18, 17, 16, 14, 14, 17, 18, 13, 85, 2, 0, 1, 4, 5, 1, 1, 0, 1, 1, 2, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 2, 0, 0, 1, 0, 0, 1, 2, 2, 1, 1,
      0, 20, 7,
    ],
    '5.17.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11016, 49630, 23297, 18125, 13336,
      13345, 12219, 10910, 10495, 14557, 13362, 11959, 8310, 4440, 6836, 8796, 8261,
      8210, 7619, 7747, 6896, 7962, 7683, 8691, 7288, 4865, 5347, 5415, 5706, 5535,
      5491, 4073, 4980, 4652, 4867, 4901, 4956, 4149, 4729, 4491, 4879, 4387, 4125,
      4476, 4423, 4539, 4245, 2308, 4080, 12357, 3340, 2887, 3594, 3314, 5324, 2959,
      2953, 1799, 1065, 1885, 3199, 2901, 3109, 6627, 3540, 2733, 2953, 6369, 3151,
      3211, 3203, 2815, 2572, 2732, 2545, 2280, 2895, 2392, 5040, 2382, 2379, 2245,
      2059, 2758, 1857, 2049, 1551, 1570, 1790, 2069, 1499, 1941, 11090, 2812, 2730,
      2234, 8270, 5511, 1800, 2021, 1648, 1878, 1659, 1679, 749, 2083, 2273, 1891,
      1835, 2046, 2306, 2331, 2273, 2775, 2024, 2245, 2614, 2304, 1938, 1958, 2080,
      1465, 1350, 1635, 1486, 1564, 1637, 1728, 2187, 2185, 1967, 2267, 1870, 2000,
      1883,
    ],
    '7.8.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10123, 76466, 30841,
      22034, 15218, 13824, 13702, 13276, 9971, 9776, 6605, 5780, 6041, 6271, 6103,
      5714, 4557, 4707, 3984, 4256, 5860, 4302, 2148, 5215, 4965, 3929, 4344, 6151,
      5101, 5128, 4354, 3445, 2347, 2743, 3423, 3368, 3723, 3045, 2886, 2921, 4288,
      3881, 3514, 3476, 3487, 2714, 2330, 2348, 2668, 2642, 3117, 2690, 2879,
    ],
    '7.22.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 15136, 99895, 80701, 23432, 17780, 14585, 14023, 13486,
      12049, 4986, 9229, 17404, 16620, 13628, 17095, 15365, 15015, 16388, 12203,
      9383, 14866, 14826, 12505, 16732, 11751, 7648, 8735, 10117, 10473, 9161, 8379,
      9065, 10262, 11046, 11072, 11026, 10331, 10923, 9444, 9047,
    ],
    '6.16.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10984, 69835, 28553, 17817, 12398,
      12322, 11416, 6504, 3833, 6170, 9236, 10379, 11605, 9864, 10321, 9357, 9691,
      8226, 7773, 7848, 7879, 6422, 6993, 6935, 7140, 5348, 6250, 5472, 5749, 5729,
      5774, 6079, 6156, 5699, 5530, 5417, 3414, 3100, 3728, 3692, 3316, 3628, 3248,
      3632, 3013, 3126, 10583, 9681, 3477, 3104, 2489, 2776, 2747, 2565, 1489, 2501,
      2625, 2177, 1978, 2400, 2805, 2665, 2718, 2643, 1999, 2571, 2734, 2425, 2455,
      1843, 2027, 2351, 1859, 1865, 2452, 2100, 2267, 2108, 2126, 2087, 2155, 1942,
      2148, 2043, 1922,
    ],
    '6.20.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14918, 71708, 69412, 31419, 27215,
      23546, 19426, 16011, 15944, 14535, 12288, 12647, 12003, 11020, 11386, 8513,
      8727, 8165, 8570, 8138, 7713, 8299, 8973, 7598, 8022, 7728, 6761, 3835, 6524,
      6807, 5596, 5948, 6477, 6120, 5671, 5327, 5829, 5092, 5812, 5903, 5866, 4274,
      3529, 3374, 2998, 3411, 3814, 3680, 3759, 3412, 3309, 2929, 2949, 3272, 3111,
      2953, 2606, 2432,
    ],
    '7.0.0-beta.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 167, 5658, 5213, 912, 681, 648, 724, 799, 853, 729, 584, 503,
      492, 576, 1024, 655, 740, 360, 315, 314, 391, 560, 361, 146, 159, 176, 200,
      209, 224, 225, 334, 402, 119, 661, 212, 31, 128, 97, 35, 60, 68, 43, 195, 30,
      73, 97, 248, 63, 81, 53, 48, 113, 54, 19, 19, 29, 20, 23, 115, 27, 28, 110,
      110, 34, 59, 24,
    ],
    '5.0.0-beta.1': [
      754, 700, 737, 766, 527, 532, 591, 490, 383, 438, 497, 449, 449, 472, 409,
      3474, 390, 455, 498, 467, 642, 511, 533, 606, 1433, 453, 533, 424, 407, 375,
      500, 554, 403, 916, 511, 541, 885, 485, 578, 644, 1582, 590, 548, 582, 574,
      306, 342, 547, 464, 797, 501, 424, 377, 315, 327, 336, 318, 272, 467, 536, 307,
      347, 277, 435, 3878, 317, 412, 446, 716, 991, 409, 431, 259, 166, 231, 336,
      292, 332, 931, 323, 420, 353, 1492, 380, 290, 498, 605, 591, 409, 519, 380,
      550, 432, 1338, 477, 342, 295, 322, 510, 355, 253, 330, 287, 330, 295, 264,
      245, 715, 216, 231, 223, 1322, 740, 171, 258, 153, 174, 123, 204, 85, 179, 195,
      131, 107, 169, 127, 118, 118, 128, 100, 107, 98, 145, 81, 102, 72, 78, 123,
      170, 148, 90, 84, 68, 83, 82, 99, 91, 109, 71, 89,
    ],
    '5.8.0': [
      9623, 10265, 10008, 7757, 7787, 6445, 7627, 7601, 7005, 6786, 6896, 7195, 6800,
      6905, 6296, 6566, 5856, 6659, 7227, 8666, 9539, 8113, 8593, 6518, 8409, 4743,
      6068, 5739, 2764, 3113, 5305, 4732, 4610, 5356, 4874, 4226, 4423, 3398, 3683,
      4180, 3176, 3125, 3088, 3461, 3406, 3033, 3376, 3469, 3536, 8902, 3693, 4545,
      3698, 4424, 3199, 4992, 4148, 3765, 4224, 4291, 4006, 4198, 3172, 4334, 10598,
      2862, 1885, 1761, 1937, 3060, 1401, 1323, 1052, 708, 868, 1275, 1277, 1370,
      3911, 1492, 1546, 1677, 4406, 1301, 1249, 1243, 1412, 1319, 1104, 1280, 1284,
      1478, 1302, 10751, 1270, 1411, 1408, 1453, 4404, 1383, 1557, 1498, 1340, 1555,
      1552, 1681, 1517, 2612, 1113, 1235, 1384, 6193, 3789, 1313, 1620, 1262, 1120,
      1244, 1405, 673, 1469, 1579, 1279, 1034, 1654, 1474, 1438, 1640, 1610, 1267,
      1378, 1473, 1165, 1338, 1138, 1190, 1080, 1163, 1201, 1207, 1464, 1533, 1511,
      1396, 1354, 1482, 1483, 1222, 1290, 1321,
    ],
    '5.5.1': [
      10995, 9922, 9624, 9810, 10044, 7940, 9412, 8428, 9124, 7718, 7874, 7512, 7122,
      7036, 7461, 7260, 7227, 5323, 6586, 8428, 8777, 8517, 7486, 7814, 9173, 5830,
      6585, 6306, 4021, 4862, 7061, 5811, 5502, 5727, 5804, 5688, 16731, 5800, 5026,
      4905, 21631, 3755, 4159, 3677, 3836, 3541, 3529, 3164, 3623, 8537, 3338, 3465,
      3025, 2443, 2351, 2791, 2583, 2990, 2922, 2715, 2394, 2642, 1559, 2460, 8995,
      1966, 2331, 2302, 2080, 4002, 2040, 2188, 1188, 701, 1346, 1789, 1615, 1698,
      4053, 1501, 1625, 1789, 24644, 1817, 1619, 1558, 1410, 2252, 1818, 2319, 1232,
      1193, 1371, 9905, 1123, 1083, 1068, 1191, 3204, 1388, 1172, 1004, 993, 1025,
      978, 1173, 961, 2212, 862, 1092, 1208, 5741, 3479, 2402, 2996, 3245, 2534,
      1970, 1760, 1260, 2163, 2703, 2330, 2025, 2751, 2980, 2874, 2663, 2665, 2141,
      2347, 2571, 2344, 2359, 1937, 1106, 2330, 2353, 2793, 4144, 3885, 3459, 2936,
      4246, 4540, 3098, 1522, 2392, 1192, 847,
    ],
    '8.5.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16588, 63342, 62242, 28704, 14770, 13536,
      12329, 10719,
    ],
    '5.17.23': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 20157, 28791, 23817, 20355, 18182, 17879, 13513, 13970,
      14443, 16476, 14951, 13346, 12732, 11787, 12052, 11039, 11547, 11806, 11321,
      10811, 11173, 11018, 11674, 9544, 9759, 12232, 11450, 11082, 5532, 8482, 10146,
      8785, 8478, 9641, 9565, 5996, 5271, 5405, 2895, 1089, 2511, 4412, 3530, 3047,
      3753, 4351, 3092, 3904, 15231, 4614, 4502, 4914, 4859, 4201, 3980, 4193, 3447,
      4120, 4288, 11059, 3445, 3449, 4041, 3188, 4850, 3340, 3619, 1563, 1196, 1392,
      1541, 1399, 1598, 1484, 1128, 1049, 1112, 4328, 3679, 1572, 1796, 1966, 1968,
      1705, 1016, 651, 903, 1264, 907, 890, 1435, 1246, 1015, 921, 1041, 789, 967,
      1178, 1212, 1128, 931, 973, 938, 1114, 1420, 1564, 1538, 1383, 1678, 1476,
      1451, 1830, 1830, 1819, 1467, 1748,
    ],
    '7.19.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 11343, 100819, 40563, 29144, 23649, 21937, 21302, 20421, 16630, 21090,
      20216, 20015, 9443, 16978, 14876, 11912, 11668, 13877, 14631, 11819, 13802,
      13254, 10606, 13682, 13926, 12308, 10472, 9553, 8607, 8183, 8389, 10300, 7834,
      10809, 11894, 10857, 9569, 9259, 9159, 8743, 10329, 10149, 17257,
    ],
    '6.0.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11208, 29020, 14778, 13796, 12640,
      13175, 14668, 11698, 12638, 12588, 10384, 13324, 11037, 24276, 31982, 16106,
      10584, 11977, 9335, 8226, 10707, 10728, 10781, 6027, 10320, 9631, 9200, 8540,
      8090, 7127, 6922, 6785, 6939, 5359, 3175, 4333, 6790, 6930, 6570, 7503, 6958,
      6645, 6524, 6553, 6476, 6875, 6865, 6795, 6615, 5386, 5865, 5958, 5918, 6007,
      12906, 6709, 6205, 5046, 5777, 9959, 7222, 6879, 5874, 6036, 5759, 5913, 5230,
      5631, 5430, 4550, 5216, 4741, 7188, 6448, 5107, 4252, 4282, 4963, 4952, 4802,
      2979, 4553, 4644, 4116, 3838, 5281, 5350, 4652, 4704, 5010, 3770, 4503, 5048,
      4410, 4317, 4007, 3739, 3439, 4111, 4015, 4489, 4217, 4114, 4031, 5729, 6049,
      5635, 3963, 3753, 3996, 3780,
    ],
    '7.0.0-alpha.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 303, 28,
      29, 16, 16, 12, 20, 11, 12, 8, 14, 8, 5, 7, 10, 7, 6, 11, 15, 14, 14, 13, 13,
      18, 17, 16, 15, 15, 15, 16, 16, 13, 1, 1, 1, 1, 2, 2, 1, 1, 0, 1, 0, 1, 2, 3,
      3, 1, 3, 3, 1, 2, 1, 2, 1, 3, 0, 1, 2, 0, 0, 2, 0, 0, 1, 0, 0, 1, 2, 2, 1, 2,
      0, 20, 8,
    ],
    '7.23.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 31364, 125742, 55151, 33246,
      30034, 25802, 21942, 23365, 23265, 19980, 22687, 19308, 18482, 32560, 35022,
      32177, 24544, 32661, 31016, 26977, 26571, 29303, 27379, 26539, 26418, 28710,
      28470, 29207, 28039, 29962,
    ],
    '7.24.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10116, 78828, 50313,
      29511, 24340, 22509, 22068, 16164, 18609, 16599, 15847, 16013, 14159, 13078,
      11905, 12303, 13229, 17483, 16580, 16650, 15553, 14801, 14658, 16678, 15881,
      15031, 15357, 16064,
    ],
    '5.17.20': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 21288, 74120, 39010, 30441, 26946, 28655, 25698, 21167, 20404,
      15582, 15212, 16806, 16321, 16270, 13914, 14431, 11264, 11900, 9630, 10143,
      14729, 10224, 8905, 8175, 9871, 9527, 10344, 9032, 9803, 9071, 9611, 4640,
      6542, 7181, 6955, 6270, 5933, 6291, 5890, 6640, 6261, 3888, 1645, 4225, 6875,
      6259, 6994, 25252, 7417, 6082, 5097, 59793, 50786, 4738, 4872, 5120, 5727,
      4886, 5786, 5374, 6270, 4830, 10669, 4358, 4987, 5648, 6162, 5834, 5194, 4619,
      4802, 4714, 3823, 3265, 3678, 4349, 3649, 3421, 2827, 3855, 6409, 15256, 2235,
      2545, 2552, 2093, 2099, 2303, 850, 1637, 2444, 2091, 3115, 24958, 6113, 1783,
      1771, 1551, 1393, 1719, 1526, 1585, 1608, 1181, 1179, 1156, 1558, 1717, 1513,
      1131, 1677, 1444, 1230, 1224, 1520, 1322, 1464, 1416, 1195,
    ],
    '8.0.0-beta.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 190, 502, 2409, 1911, 1706, 1168, 1230, 1068, 1098, 1545, 1049, 1234,
      1224, 1283, 1126, 1220, 1183, 1415,
    ],
    '5.2.0': [
      2270, 2052, 2213, 2160, 1949, 1481, 1829, 1780, 1820, 1603, 1801, 1804, 1660,
      1858, 1816, 1690, 1754, 1528, 1365, 1268, 1519, 1576, 1486, 1289, 1512, 1391,
      1227, 1183, 941, 1045, 1187, 1293, 1128, 2841, 1401, 1435, 2913, 1170, 1279,
      1293, 3680, 1012, 1088, 1098, 1162, 941, 1156, 1252, 1123, 1914, 955, 1007,
      973, 807, 908, 726, 718, 685, 760, 600, 620, 592, 298, 593, 2205, 598, 602,
      466, 549, 830, 545, 611, 552, 367, 465, 614, 620, 506, 2647, 595, 557, 577,
      3855, 391, 344, 509, 347, 347, 299, 287, 248, 263, 304, 2169, 228, 121, 206,
      184, 727, 255, 201, 227, 273, 274, 251, 230, 208, 533, 210, 275, 262, 1218,
      913, 305, 304, 296, 219, 178, 218, 121, 252, 257, 261, 245, 351, 271, 248, 265,
      271, 254, 562, 1427, 2135, 745, 634, 1921, 1906, 929, 420, 576, 549, 999, 1320,
      3743, 4378, 2427, 947, 605, 316, 279,
    ],
    '5.17.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 41534, 17805, 12595, 11649, 8898, 8264,
      7613, 9419, 8314, 7956, 8868, 5759, 6203, 5967, 5397, 3826, 1696, 3329, 4402,
      4340, 4722, 4832, 3758, 3260, 3954, 3191, 3064, 4267, 2998, 2782, 3056, 2955,
      3013, 2952, 3021, 3145, 3035, 3560, 3385, 4305, 3526, 4855, 3570, 4707, 4159,
      4016, 4046, 4108, 4503, 4270, 2701, 3581, 15560, 4519, 4108, 3863, 3938, 6443,
      4845, 5081, 2316, 797, 1832, 4089, 4038, 4180, 6317, 4109, 5150, 5286, 6950,
      5564, 5425, 5745, 4169, 4370, 4144, 5680, 4960, 4071, 3424, 5479, 3657, 4645,
      4280, 4567, 5308, 3893, 5249, 6755, 5378, 5256, 4984, 4662, 4596, 5349, 4700,
      4860, 4105, 6977, 4749, 3807, 5655, 5754, 3820, 3441, 2880, 818, 3660, 3263,
      3543, 2833, 2700, 5809, 5244, 7908, 6576, 4489, 6482, 3841, 4670, 5383, 5121,
      13737, 6497, 6527, 7714, 7981, 16633, 26262, 34476, 28686, 28444, 14600, 28554,
      34950, 19746, 17898,
    ],
    '5.17.24': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 71306, 37868, 22250, 20429, 19301, 13609, 12335,
      12611, 13712, 12892, 10748, 11154, 11318, 9171, 8727, 8797, 8617, 7771, 8489,
      6736, 7565, 6754, 7733, 6613, 6786, 6451, 6458, 3612, 5506, 5250, 4187, 4332,
      4580, 4909, 6050, 6051, 6062, 3315, 1895, 3419, 5490, 5791, 5505, 8055, 6900,
      7471, 6783, 25209, 6024, 6385, 6792, 6319, 6154, 5990, 5815, 3619, 3547, 3885,
      9673, 4967, 4432, 4560, 4740, 4248, 2796, 2694, 2149, 2114, 2572, 2485, 2758,
      2888, 2670, 2053, 2034, 2098, 4575, 4326, 2466, 2508, 1953, 2389, 2363, 2242,
      1187, 2446, 2282, 1704, 1747, 2147, 2685, 2297, 2261, 2572, 1986, 2382, 2667,
      2550, 2373, 2404, 2072, 2072, 2103, 2265, 2534, 2163, 2336, 2322, 2017, 1997,
      2179, 2291, 2696, 2466, 2470,
    ],
    '7.11.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30821,
      22495, 20628, 19878, 16561, 15628, 14563, 14090, 13617, 12420, 14962, 14896,
      13623, 11774, 10223, 10550, 10220, 9957, 4135, 7617, 7929, 5528, 5561, 7335,
      7265, 5767, 5582, 5789, 4681, 5395, 5831, 6044, 6149, 5817, 4968, 4277, 5311,
      5429, 4906, 4893, 4564, 5012, 5499, 5448, 4877, 4286, 4308, 4488, 3935,
    ],
    '6.0.0-alpha.15': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 79, 212, 126, 32, 30, 33, 36, 20, 37, 23, 29, 3, 4, 1, 13, 19, 28,
      22, 22, 21, 1, 6, 13, 19, 37, 54, 34, 41, 60, 13, 4, 4, 6, 3, 8, 14, 2, 1, 3,
      5, 4, 4, 2, 3, 2, 12, 17, 16, 25, 13, 10, 13, 19, 8, 10, 14, 9, 6, 8, 9, 8, 9,
      11, 33, 14, 21, 13, 17, 22, 17, 20, 15, 15, 16, 18, 19, 17, 6, 2, 2, 3, 4, 4,
      1, 1, 1, 4, 1, 1, 2, 2, 0, 2, 2, 0, 1, 5, 0, 2, 1, 1, 0, 2, 3, 2, 0, 2, 2, 2,
      1, 0, 1, 2, 2, 2, 2, 0, 1, 21, 9,
    ],
    '5.17.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15840, 54658, 24568, 18343,
      15881, 13924, 13046, 10740, 11443, 9961, 9405, 8359, 4456, 7442, 9290, 8603,
      8362, 7598, 6961, 7371, 7489, 7768, 7473, 7557, 4664, 5806, 4652, 5151, 5172,
      4782, 5550, 5603, 4557, 4545, 4346, 4396, 3388, 3759, 3916, 4149, 3803, 3567,
      3857, 3566, 3128, 3037, 1552, 3261, 3140, 2892, 2427, 2903, 3130, 4576, 2215,
      2460, 1758, 661, 1580, 2364, 2526, 2450, 5446, 2403, 2283, 2352, 5377, 2275,
      1946, 2061, 1562, 1630, 1439, 1803, 1303, 1642, 1536, 4305, 1635, 1354, 1474,
      1311, 1836, 1460, 1634, 1172, 1148, 1144, 1129, 1093, 1149, 1138, 1395, 1366,
      1375, 9746, 6297, 1260, 1131, 1122, 1443, 1595, 1409, 643, 1215, 1294, 992,
      935, 1671, 1345, 1738, 1431, 1332, 1154, 1485, 1467, 1313, 1325, 1254, 1167,
      951, 1083, 1119, 1724, 1326, 1703, 1155, 2199, 2304, 1695, 1266, 1842, 1231,
      1083,
    ],
    '6.16.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19501, 99848, 44179, 18561, 17760,
      14974, 8846, 4267, 7217, 11682, 10084, 9811, 10375, 10565, 9854, 10514, 9635,
      8485, 8173, 9090, 6771, 7151, 8095, 7251, 6306, 6258, 6220, 5701, 6465, 7204,
      5571, 5737, 4626, 5505, 5418, 4314, 4150, 4302, 4490, 4828, 4931, 5134, 4665,
      4814, 4729, 19288, 16569, 3525, 4049, 3216, 3669, 3691, 3679, 1733, 3596, 3928,
      3155, 3194, 4405, 4156, 4265, 3936, 3766, 3191, 3925, 3819, 3972, 5002, 6139,
      5864, 6225, 5695, 6081, 6304, 5641, 4605, 3644, 4052, 4093, 4137, 3574, 3671,
      3891, 4300,
    ],
    '8.0.0-alpha.13': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 136, 265,
      38, 24, 26, 21, 35, 40, 16, 33, 30, 6, 1, 0, 1, 1, 2, 2, 1, 3, 0, 20, 8,
    ],
    '5.11.1': [
      18098, 17012, 15864, 14228, 14429, 12236, 13276, 13784, 12048, 12646, 12064,
      11082, 8575, 9578, 9199, 9852, 9047, 8666, 9301, 9225, 9332, 9654, 10674,
      10133, 9539, 9212, 9814, 7694, 5207, 7819, 9708, 7237, 7070, 8290, 7050, 7482,
      6304, 5832, 6732, 7704, 5260, 5045, 4527, 5142, 4312, 5083, 5972, 4730, 5015,
      30209, 4711, 5374, 5277, 5570, 5377, 5614, 6177, 6635, 7046, 5243, 6127, 7177,
      2724, 4177, 13658, 4695, 4009, 4043, 4328, 5276, 3436, 3758, 2481, 1299, 2313,
      3240, 3820, 3358, 8193, 3978, 5128, 5452, 8800, 4549, 6766, 5379, 4969, 4884,
      5049, 5228, 5389, 5854, 4554, 41468, 3962, 4973, 4114, 4893, 8825, 5835, 5075,
      3999, 4470, 5064, 4949, 5797, 6814, 7099, 6415, 7128, 6963, 9375, 7341, 4326,
      6029, 5348, 4532, 5493, 5096, 3202, 3813, 4731, 3233, 4064, 4377, 4358, 5682,
      3758, 3553, 4012, 4476, 5399, 5006, 5572, 5351, 3849, 3407, 4287, 5253, 5699,
      3459, 4333, 5211, 5601, 5590, 4428, 4145, 5063, 5653, 6381,
    ],
    '4.0.2': [
      14772, 14384, 15027, 14409, 15206, 13773, 18000, 16038, 18542, 17822, 18119,
      17482, 17061, 19456, 19193, 18972, 20057, 18499, 20821, 20247, 15874, 15489,
      16367, 12689, 21632, 17270, 17017, 13129, 7084, 13275, 16164, 16395, 16303,
      20105, 18311, 17511, 22959, 19206, 18581, 20108, 31104, 15871, 16774, 17507,
      15361, 14855, 16374, 16770, 15872, 21168, 16261, 15431, 15297, 15420, 12678,
      15037, 15736, 15393, 15063, 14008, 13218, 14398, 8423, 15134, 34884, 16920,
      18656, 19456, 19360, 23128, 17280, 16408, 9732, 5079, 10146, 15643, 14934,
      18298, 27481, 17104, 15853, 15830, 32371, 19628, 18146, 16382, 13019, 14112,
      14550, 13775, 11082, 11088, 10753, 27536, 10334, 10927, 11739, 10488, 13951,
      9917, 9255, 9939, 9976, 13255, 15169, 14642, 15736, 21225, 16549, 15373, 16670,
      30178, 24553, 15168, 17605, 14599, 14862, 13049, 11552, 5622, 9989, 12028,
      9191, 8786, 11852, 12366, 11334, 12056, 12379, 10239, 12437, 13333, 10298,
      13459, 13181, 11869, 11228, 12977, 14189, 13603, 11676, 12492, 12197, 11333,
      11228, 11653, 12308, 13378, 12942, 16236,
    ],
    '6.19.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 18326, 132658, 63373, 49137, 43014, 34089, 28325, 23393, 23033, 16201,
      17260, 15410, 12579, 13942, 12606, 11401, 11947, 10834, 11603, 10973, 9983,
      9403, 9011, 9372, 9656, 9677, 8499, 8632, 9030, 9497, 8587, 8281, 8117, 7844,
      7330, 7597, 7967, 7574, 3515, 7728, 6490, 5105, 5148, 6702, 6040, 5542, 5640,
      5542, 4680, 5464, 6035, 5497, 6378, 5497, 5495, 6005, 6395, 6985, 5645, 6350,
      6232, 6202, 9362, 9371, 6317, 6566, 5649, 6330, 7162,
    ],
    '6.18.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29630, 64167, 16057,
      24690, 29855, 26449, 23753, 26545, 23535, 21378, 19255, 18023, 16836, 16037,
      15604, 12740, 12850, 12085, 12803, 11342, 11879, 10130, 9484, 10141, 9787,
      8949, 9889, 8335, 8076, 7315, 5418, 4645, 5051, 5371, 4556, 4828, 3942, 4330,
      4310, 3938, 3665, 3452, 3870, 4544, 3745, 4236, 3783, 4129, 2312, 3245, 3393,
      2811, 2814, 3115, 3135, 2744, 2463, 2831, 2185, 2946, 3242, 3326, 3199, 2832,
      2865, 2562, 2327, 2132, 2423, 2697, 2494, 2483, 1858, 1859, 2210, 1778, 2076,
      2097, 1845,
    ],
    '7.29.5': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 45370, 91705, 26978, 20382, 20391, 16751, 16534,
      15993, 13859, 15524,
    ],
    '5.17.18': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 19586, 80652, 42115, 28118, 26131, 26434, 17174, 17535, 16371, 14998,
      15445, 11996, 10583, 10250, 10051, 9237, 8591, 8634, 8396, 8368, 7979, 7904,
      7727, 8348, 7493, 6174, 7337, 7275, 7010, 6991, 6483, 5911, 6494, 3866, 6216,
      7852, 6584, 6449, 6609, 6750, 6945, 6638, 6812, 4638, 2666, 4436, 5787, 5292,
      6441, 16867, 6075, 5696, 5974, 13551, 6048, 6062, 5338, 3990, 4654, 4467, 4567,
      4671, 4043, 4160, 8833, 4384, 3835, 3478, 3964, 4681, 4047, 4365, 3967, 4513,
      4332, 4540, 3373, 3479, 2916, 2648, 3110, 3316, 6005, 5519, 3145, 3091, 2608,
      3134, 2942, 2332, 1274, 2104, 2705, 1801, 2194, 2391, 2451, 2475, 2543, 2266,
      1514, 1990, 1963, 2028, 2160, 1831, 2258, 1921, 2420, 2325, 2271, 2262, 2178,
      1904, 2090, 2113, 2052, 1648, 1897, 1740, 1837,
    ],
    '6.0.0-alpha.13': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 103, 94, 189, 126, 55, 103, 56, 56, 77, 63, 78, 33, 35, 26, 29, 12, 14, 12,
      53, 29, 37, 23, 72, 5, 2, 1, 3, 4, 4, 3, 3, 4, 1, 3, 0, 5, 0, 7, 12, 2, 1, 2,
      2, 2, 1, 1, 3, 2, 11, 18, 17, 22, 11, 10, 7, 19, 5, 7, 10, 8, 5, 7, 9, 7, 6,
      11, 52, 14, 15, 13, 13, 18, 17, 16, 16, 14, 15, 17, 18, 14, 4, 2, 0, 1, 2, 3,
      2, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0,
      1, 0, 0, 1, 2, 2, 1, 0, 1, 20, 8,
    ],
    '8.5.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10700, 13829, 70944, 35754, 24939,
      22135, 22775,
    ],
    '7.28.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      12486, 164123, 65924, 61615, 54301, 51087, 41212, 48514, 48965, 40546, 41934,
      40930, 37172, 36575, 36441, 36959, 33849, 34886, 35075, 43143,
    ],
    '7.10.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16891, 73559,
      15624, 13135, 13758, 13348, 10474, 11332, 9163, 7664, 7560, 7914, 6844, 6584,
      6408, 6813, 5600, 6563, 5928, 5174, 2709, 4526, 5014, 3918, 4128, 4755, 4247,
      4742, 5224, 5312, 3710, 4640, 5214, 4692, 4722, 3883, 3907, 2890, 3366, 3964,
      5221, 4003, 4078, 3121, 2959, 2963, 3410, 3945, 3305, 3686, 3360,
    ],
    '7.4.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7801, 57212, 20155, 13446, 11492, 8957,
      7535, 7678, 6502, 6956, 6169, 5030, 5192, 5698, 6228, 5619, 5638, 5870, 5604,
      5517, 4193, 3619, 3877, 3790, 3667, 3695, 4189, 3695, 3155, 2018, 3299, 3378,
      3186, 2430, 3565, 3844, 3599, 3812, 3757, 3147, 2931, 2194, 2587, 3185, 3163,
      2176, 2076, 2674, 2783, 3209, 2261, 2755, 3620, 3380, 3483, 3736, 3196, 2817,
      3564, 3776,
    ],
    '5.17.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6725, 51520, 19108, 16379, 13921,
      10641, 9806, 10163, 9861, 10137, 10061, 8763, 6087, 5106, 2962, 4562, 5939,
      5723, 4724, 4905, 5351, 3927, 4222, 3728, 3754, 3513, 2755, 2531, 2712, 2875,
      2692, 2071, 2790, 2903, 2645, 2335, 2916, 2830, 2567, 2135, 2391, 2335, 2284,
      1850, 2228, 2435, 2303, 2470, 1509, 2718, 52560, 2359, 2214, 2554, 2549, 4177,
      2629, 2689, 1752, 940, 1630, 1864, 1813, 2072, 3832, 1996, 1956, 2009, 3635,
      2209, 2161, 1966, 1501, 1448, 1939, 1807, 2881, 1805, 1411, 2763, 1165, 1422,
      1174, 1318, 1583, 1346, 1730, 1154, 1208, 1882, 2444, 1132, 1379, 5984, 867,
      909, 1017, 5931, 3962, 975, 959, 1045, 1047, 1074, 1088, 551, 959, 1089, 793,
      907, 1285, 1392, 993, 825, 1143, 741, 870, 932, 1062, 1739, 2989, 2398, 2526,
      3451, 3955, 4250, 4532, 2854, 2118, 1639, 1633, 1745, 1410, 2109, 2105, 2368,
    ],
    '5.6.1': [
      17119, 15309, 15687, 14157, 24665, 19482, 16283, 17045, 12212, 10803, 12216,
      11100, 10223, 9973, 8708, 8214, 7747, 8041, 8406, 13434, 10436, 6139, 6516,
      5723, 5369, 5020, 4581, 3723, 1896, 3689, 4398, 4019, 4863, 4698, 4883, 4178,
      4722, 4145, 4079, 3678, 37980, 2808, 3031, 3104, 2795, 2649, 3653, 3840, 3452,
      13751, 3170, 3425, 3276, 2538, 2066, 2656, 2559, 2305, 3310, 2379, 1829, 2136,
      1644, 2464, 10184, 2702, 2791, 3035, 3062, 4348, 3269, 3359, 2397, 1725, 2314,
      3125, 2645, 2998, 5561, 3666, 3188, 3791, 5309, 3029, 3605, 3037, 3140, 2460,
      3552, 2967, 2702, 2407, 3177, 18746, 2700, 1850, 2281, 2114, 4757, 2572, 1602,
      1795, 1706, 1458, 1616, 1414, 1392, 3193, 1723, 1593, 1532, 11005, 6533, 1329,
      1298, 1181, 1329, 1127, 1034, 555, 1280, 1065, 952, 997, 1385, 1603, 1552,
      1281, 1773, 1227, 1528, 1373, 1252, 1694, 1392, 1093, 1195, 963, 1065, 1264,
      1322, 1967, 1425, 1669, 1734, 2108, 2155, 2846, 2858, 1499,
    ],
    '5.12.1': [
      39510, 21456, 16455, 12773, 11986, 8802, 9861, 8721, 7347, 6855, 7908, 7430,
      6739, 6626, 6307, 6701, 6184, 5768, 5473, 5972, 4983, 5547, 6008, 4467, 5841,
      6217, 6499, 6294, 4560, 4053, 5913, 5516, 5217, 6123, 4866, 4782, 4449, 3848,
      3791, 3640, 2739, 2647, 3702, 2851, 3055, 2927, 3774, 2893, 2458, 2492, 2603,
      2765, 2137, 2591, 1919, 2167, 2609, 2181, 2223, 2033, 1725, 1890, 1070, 1881,
      8282, 1874, 2223, 2165, 1908, 3137, 1722, 2043, 1124, 441, 1045, 2323, 2048,
      2300, 5703, 2018, 2423, 1732, 4154, 1861, 1804, 1241, 1166, 1397, 1364, 1839,
      1828, 1802, 1199, 2620, 1446, 1386, 1294, 1410, 4697, 1733, 1457, 1511, 1153,
      1724, 1755, 1418, 1717, 2690, 1500, 1395, 1569, 4562, 3187, 1578, 1737, 1340,
      1529, 1508, 1045, 470, 975, 1127, 910, 973, 1215, 1280, 1104, 1178, 1151, 1031,
      1398, 1391, 1368, 1317, 973, 1413, 1246, 1220, 1434, 1648, 1282, 941, 1221,
      1152, 1131, 1301, 1349, 1256, 1674, 1380,
    ],
    '5.4.0': [
      2444, 2209, 2512, 1928, 2049, 1755, 2344, 1789, 1825, 2144, 1729, 1588, 1648,
      1582, 1497, 1736, 1533, 1247, 1225, 1702, 1545, 1472, 1863, 1487, 1791, 1625,
      1903, 1300, 722, 1059, 1517, 1420, 1381, 7254, 1298, 1509, 2585, 1458, 1161,
      1230, 3491, 418, 510, 530, 425, 422, 431, 453, 435, 1687, 414, 492, 446, 526,
      445, 443, 443, 588, 561, 543, 623, 604, 1170, 2390, 4135, 2282, 2230, 2292,
      2106, 840, 1557, 1925, 696, 236, 384, 466, 499, 599, 7103, 501, 480, 426, 2975,
      316, 363, 359, 367, 406, 338, 320, 347, 349, 286, 2156, 353, 270, 407, 426,
      847, 271, 242, 420, 386, 470, 373, 356, 469, 955, 232, 275, 314, 1563, 810,
      344, 413, 229, 232, 381, 591, 225, 298, 246, 149, 353, 278, 559, 343, 340, 343,
      258, 313, 268, 225, 219, 211, 182, 194, 176, 169, 205, 124, 240, 171, 174, 174,
      280, 231, 411, 467, 329,
    ],
    '5.3.0': [
      8388, 6506, 7435, 2491, 8216, 3726, 2013, 1771, 1653, 1901, 1881, 1784, 1624,
      1855, 1477, 1332, 1480, 1588, 1713, 1721, 1351, 1349, 1134, 1018, 992, 1019,
      1115, 941, 612, 875, 1422, 1086, 1075, 5269, 831, 1091, 2630, 848, 1055, 1072,
      8326, 771, 802, 975, 672, 802, 868, 1006, 747, 2634, 642, 771, 1028, 838, 1079,
      1124, 1088, 1170, 762, 1325, 2042, 2066, 313, 496, 1922, 584, 653, 757, 768,
      758, 639, 600, 395, 207, 273, 644, 682, 693, 5723, 774, 571, 641, 5945, 443,
      512, 376, 237, 338, 447, 270, 251, 498, 216, 3979, 206, 174, 186, 124, 1779,
      241, 178, 165, 95, 208, 190, 225, 179, 451, 151, 133, 129, 1019, 724, 191, 97,
      120, 103, 182, 120, 58, 129, 97, 69, 75, 184, 122, 130, 108, 123, 155, 125, 75,
      129, 157, 186, 70, 59, 83, 106, 64, 132, 144, 141, 235, 235, 159, 167, 191,
      231, 58,
    ],
    '6.19.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 41172, 88064, 100036, 55566, 46518, 30756, 28087, 24084,
      20072, 20400, 17398, 16712, 16283, 13806, 16533, 16387, 13484, 11926, 12536,
      12962, 9897, 12624, 11625, 8940, 9999, 11426, 14469, 13915, 9686, 10508, 7476,
      8454, 9261, 9861, 19847, 11872, 9319, 10036, 8093, 12589, 20998, 12331, 10507,
      7764, 6813, 7616, 8648, 6519, 6003, 6366, 5266, 5216, 6040, 6456, 5332, 5739,
      5197, 4555, 5069, 5078, 4971, 4334, 5890, 5221, 4615,
    ],
    '7.11.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20074, 20902,
      17745, 15853, 14329, 11699, 11908, 8342, 8717, 8149, 9033, 6434, 6191, 7300,
      8237, 6245, 6137, 5756, 5858, 2917, 6717, 6199, 4706, 4661, 5649, 6242, 6214,
      5390, 6186, 5006, 6091, 6643, 5320, 5340, 5447, 5348, 3604, 3699, 4580, 4042,
      3833, 4657, 4487, 4088, 4035, 4331, 3773, 4212, 3970, 3542,
    ],
    '8.3.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 20356, 50247, 23175, 20237, 16195, 14839, 14707, 14387,
      13377, 12518, 12421, 10801,
    ],
    '6.7.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7455,
      59767, 27286, 22749, 19813, 17767, 14362, 12554, 11578, 10706, 8487, 9779,
      5171, 10003, 8612, 8942, 8293, 8958, 10729, 7475, 7221, 8234, 3977, 1362, 3551,
      6656, 5904, 5585, 6158, 6347, 5395, 5235, 6204, 5515, 4773, 4735, 4285, 4883,
      4313, 4267, 3420, 4200, 4068, 3302, 3543, 3973, 4093, 3841, 6684, 3440, 3226,
      5123, 4662, 4742, 3996, 3578, 4002, 4195, 4151, 3865, 3644, 7588, 6718, 3543,
      3605, 2779, 2831, 2781, 2705, 1373, 2577, 2424, 2145, 2137, 2734, 2546, 3092,
      3074, 2636, 1809, 3941, 2304, 2221, 2143, 2376, 2238, 1999, 2222, 2072, 1914,
      1714, 2070, 2253, 2392, 2396, 2127, 1936, 2144, 2097, 1809,
    ],
    '7.3.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 63771, 36061, 27944, 22356, 21117, 22759,
      17940, 16887, 16965, 15694, 15207, 9206, 8737, 10359, 11262, 9043, 10033, 9440,
      9768, 10440, 8937, 10438, 10949, 10617, 10661, 8742, 11126, 9259, 10025, 4419,
      7235, 8163, 5793, 6335, 8522, 8224, 6795, 6631, 6296, 5168, 5680, 6266, 7470,
      17789, 15305, 15139, 14199, 7030, 4214, 5387, 4101, 6023, 4078, 4660, 4617,
      4252, 3278, 4327, 4518, 3877,
    ],
    '6.12.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 22712, 30257, 26788, 23421, 19057, 19501, 16350,
      10390, 9861, 8779, 5912, 2882, 5067, 7867, 7854, 7307, 7173, 7286, 7110, 7233,
      7063, 7776, 7898, 6882, 6327, 6625, 6618, 6607, 8428, 6347, 5946, 5889, 5302,
      5212, 4754, 4551, 3833, 4434, 3967, 3687, 3453, 4200, 4023, 3757, 3837, 5437,
      3897, 4118, 3532, 9252, 8536, 2730, 3114, 3124, 3631, 3039, 3083, 1123, 2985,
      2874, 2638, 2058, 2764, 2701, 3104, 2646, 2709, 2265, 2697, 2945, 3049, 4442,
      3957, 3352, 2811, 4062, 3959, 4191, 3868, 4037, 3945, 3266, 3264, 4527, 3893,
      3180, 3831, 4205,
    ],
    '5.17.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9360, 61644, 25493, 20267, 16895, 14322,
      14895, 13448, 13862, 12930, 11468, 10104, 10287, 10042, 8899, 8428, 4219, 7028,
      8971, 8177, 7488, 7310, 7520, 6847, 6257, 5544, 5812, 5575, 4792, 4291, 4606,
      4461, 3628, 3363, 3530, 3536, 3264, 3036, 3425, 3134, 2930, 2591, 2563, 2926,
      2834, 2850, 2610, 2123, 2085, 2364, 1617, 2566, 22349, 2512, 2925, 2626, 2611,
      4339, 2346, 2653, 1604, 1113, 1627, 2283, 2546, 2391, 5892, 2503, 2155, 2143,
      5251, 2302, 2211, 2391, 1665, 1797, 1863, 1674, 1271, 1312, 1337, 3185, 1279,
      1031, 1016, 1097, 1456, 1035, 1064, 1078, 1091, 1296, 1248, 936, 999, 4090,
      937, 1347, 1404, 8032, 4900, 1253, 1030, 1075, 1216, 1205, 864, 607, 714, 820,
      680, 747, 1033, 1122, 1043, 948, 900, 1041, 1084, 946, 973, 960, 854, 772, 610,
      766, 770, 764, 825, 707, 639, 723, 741, 857, 712, 556, 602, 777,
    ],
    '7.0.0-alpha.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 47, 47, 58, 32, 18, 13, 33,
      64, 43, 38, 20, 38, 17, 38, 18, 16, 28, 14, 7, 8, 29, 15, 33, 17, 20, 17, 20,
      30, 29, 46, 22, 16, 15, 14, 17, 19, 22, 17, 1, 2, 1, 5, 5, 11, 8, 4, 0, 1, 0,
      0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 5, 1, 5, 3, 1, 4, 0, 1, 0, 0, 1, 2,
      2, 1, 1, 0, 20, 8,
    ],
    '6.0.0-alpha.12': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      167, 347, 74, 73, 97, 170, 233, 172, 95, 163, 160, 160, 60, 105, 90, 147, 18,
      1, 3, 4, 3, 10, 2, 3, 4, 3, 6, 3, 6, 6, 3, 3, 6, 1, 5, 2, 5, 0, 9, 20, 3, 1, 2,
      3, 3, 2, 1, 2, 2, 11, 18, 16, 70, 11, 16, 7, 79, 9, 9, 11, 8, 5, 8, 13, 7, 6,
      11, 14, 19, 21, 15, 16, 18, 18, 16, 15, 15, 15, 17, 18, 19, 5, 2, 5, 1, 4, 4,
      1, 4, 0, 0, 2, 0, 1, 0, 1, 0, 0, 3, 0, 0, 1, 1, 1, 3, 0, 0, 1, 0, 0, 1, 0, 0,
      1, 0, 0, 1, 2, 2, 1, 3, 0, 20, 8,
    ],
    '6.0.0-alpha.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 173, 188, 66, 43,
      48, 19, 18, 19, 4, 31, 16, 18, 20, 24, 20, 25, 40, 27, 13, 16, 15, 10, 9, 11,
      26, 19, 60, 262, 18, 7, 1, 3, 1, 2, 6, 4, 4, 4, 4, 7, 4, 1, 3, 0, 7, 12, 2, 1,
      5, 6, 2, 1, 1, 2, 1, 14, 18, 16, 15, 11, 10, 8, 26, 5, 8, 10, 8, 5, 7, 9, 7, 6,
      11, 18, 14, 16, 14, 13, 18, 17, 17, 15, 14, 15, 17, 18, 14, 4, 2, 0, 2, 8, 3,
      1, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 1, 6, 1, 2, 1, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0,
      1, 2, 1, 1, 2, 2, 1, 3, 3, 22, 8,
    ],
    '6.10.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 18806, 66155, 41132, 27628, 17299, 16060, 14196, 8522, 12021, 13616,
      12137, 10506, 12022, 10305, 10077, 10358, 10746, 5004, 2763, 7312, 9887, 11831,
      11850, 13255, 9282, 9408, 10322, 9478, 10519, 9516, 9228, 7957, 10700, 6670,
      6902, 7085, 6118, 5903, 5097, 4936, 4688, 5483, 9967, 7867, 5935, 6050, 11198,
      5889, 5440, 8484, 4118, 6320, 3152, 6144, 4491, 4287, 11927, 12090, 6340, 4940,
      4140, 6323, 7206, 6072, 1948, 6320, 9572, 4480, 5060, 6156, 8027, 8380, 8433,
      8371, 7387, 6107, 13789, 11761, 7415, 19768, 5766, 6212, 7175, 10338, 9737,
      10932, 9109, 13994, 9096, 9286, 8440, 13415, 8464, 8735, 6902,
    ],
    '7.22.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 18212, 54848, 40439, 30548, 22095, 24458, 22567, 21983,
      9959, 18624, 16179, 14414, 15392, 17658, 15440, 13687, 15168, 14962, 12899,
      14393, 12279, 10860, 12178, 9856, 9563, 9798, 9200, 11150, 9244, 11066, 11683,
      10670, 9099, 9152, 10224, 9619, 10404, 11461, 18789,
    ],
    '7.25.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 118159, 51816,
      37580, 31008, 27278, 22479, 26251, 18080, 17987, 19657, 15324, 17159, 14954,
      32918, 34062, 27653, 23157, 24364, 23804, 24056, 23826, 25470, 26893, 24300,
      22693, 23738,
    ],
    '6.19.10': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6487, 60703, 11000, 10711, 8805, 7570, 7483,
      7384, 6752, 6540, 6010, 6453, 5532, 4420, 4239, 4219, 4352, 3725, 3659, 3405,
      3640, 3365, 3103, 2677, 2963, 3058, 3715, 3074, 3045, 3218, 3289, 1224, 2955,
      3186, 2635, 3290, 3157, 3288, 3545, 3452, 2855, 2892, 3298, 3159, 2537, 2960,
      2495, 2152, 2220, 2652, 2487, 2627, 1927, 2023, 2659, 2068, 2071, 2212, 2445,
      2189, 2180, 2631,
    ],
    '8.0.0-alpha.10': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 256, 30, 4, 0, 2,
      1, 8, 2, 1, 2, 1, 1, 1, 0, 0, 1, 1, 2, 1, 2, 2, 1, 2, 0, 20, 8,
    ],
    '6.0.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5025, 29138, 17152, 13696, 12207, 11491,
      11030, 9618, 8035, 7751, 8060, 6925, 6666, 6449, 6800, 6201, 6115, 5863, 5978,
      6204, 5884, 4784, 4961, 5132, 5928, 3385, 6008, 5978, 5802, 5706, 5925, 5696,
      5476, 5816, 5855, 4217, 2540, 4496, 5567, 5495, 5424, 6196, 5749, 5943, 5715,
      5778, 7189, 7597, 8181, 6443, 5427, 4142, 4445, 4035, 3412, 3411, 7079, 3058,
      3062, 3644, 3737, 5009, 3650, 3732, 3595, 3376, 3602, 3577, 3516, 3765, 3028,
      3464, 3570, 3318, 5240, 4765, 3156, 3475, 3051, 3180, 3047, 3523, 2037, 3559,
      3322, 2545, 2485, 3399, 2958, 2800, 3095, 2887, 2423, 3172, 3024, 2915, 2977,
      2637, 2511, 2705, 2773, 2812, 2681, 2633, 2636, 1950, 2381, 2345, 2692, 2614,
      2953, 3308, 3135,
    ],
    '6.10.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 15565, 67668, 29391, 22113, 20185, 8631, 12872, 11995, 12628,
      11438, 11578, 10376, 10217, 8362, 7169, 4022, 2055, 3619, 7207, 6314, 6327,
      5917, 5032, 5167, 4853, 6009, 5448, 5097, 4509, 4127, 4066, 4885, 4382, 3631,
      3947, 4050, 3716, 3665, 3834, 3522, 3322, 3569, 3506, 3148, 3058, 2772, 2442,
      2696, 2265, 2756, 2984, 2586, 2407, 2197, 6055, 5760, 2403, 2534, 1775, 1823,
      2009, 1818, 759, 1630, 1698, 1367, 1366, 1778, 1598, 1708, 1699, 1849, 1576,
      1694, 2009, 2006, 2029, 1677, 1465, 1633, 2016, 2083, 1765, 1663, 1687, 1689,
      1782, 1760, 1825, 1705, 1609, 1629, 1767,
    ],
    '5.12.2': [
      23202, 48225, 21183, 13869, 13181, 10643, 11824, 11477, 9804, 8834, 8500, 7068,
      6009, 6539, 5454, 5486, 5139, 5156, 5618, 5358, 5057, 4742, 4419, 3516, 4685,
      4545, 3792, 3359, 1608, 3451, 3822, 4184, 3906, 3852, 3299, 2899, 3270, 4275,
      3931, 4575, 3039, 2936, 3476, 3578, 3399, 3452, 3333, 3833, 3623, 3687, 3900,
      3822, 3440, 2973, 2868, 3053, 3069, 2888, 3487, 2766, 2267, 1899, 1098, 1819,
      7060, 1822, 1653, 3107, 1906, 2354, 1364, 1181, 613, 170, 628, 1147, 1215,
      1354, 2701, 1049, 1067, 1198, 2654, 1211, 977, 1140, 1001, 1161, 952, 1273,
      765, 635, 592, 2755, 546, 565, 824, 762, 4376, 698, 733, 963, 781, 924, 774,
      728, 972, 1725, 920, 814, 920, 3651, 2356, 630, 570, 396, 562, 571, 576, 323,
      584, 870, 422, 559, 692, 536, 513, 436, 601, 562, 704, 663, 426, 599, 499,
      2314, 3708, 3120, 3539, 3177, 3187, 4125, 3644, 3956, 3977, 3286, 2468, 2516,
      2379, 2710,
    ],
    '4.0.1': [
      3283, 3404, 2845, 2932, 2973, 2456, 2954, 2963, 2569, 2092, 2358, 2430, 1990,
      2130, 1907, 4115, 2453, 2254, 2114, 1443, 2571, 1929, 1518, 1412, 6257, 1720,
      1730, 1473, 831, 1150, 1576, 1751, 1578, 2971, 1553, 1640, 2674, 1510, 1530,
      1962, 4331, 1348, 1331, 1191, 1199, 961, 1198, 1593, 1563, 2285, 1392, 1508,
      1672, 1421, 1673, 1550, 1099, 1239, 755, 742, 854, 1018, 561, 764, 5138, 1298,
      966, 1038, 1056, 3311, 837, 733, 736, 419, 349, 572, 589, 721, 3380, 1344,
      1305, 1111, 3330, 890, 1214, 1650, 1504, 1159, 1039, 817, 583, 1040, 1122,
      3004, 1094, 1071, 1090, 1199, 2200, 998, 1025, 906, 958, 639, 748, 1215, 925,
      2438, 1062, 753, 932, 11022, 3505, 957, 852, 1164, 956, 1098, 1006, 252, 266,
      283, 218, 245, 631, 405, 319, 389, 327, 276, 268, 372, 255, 226, 247, 274, 206,
      270, 249, 187, 207, 179, 344, 269, 298, 276, 217, 272, 213, 275,
    ],
    '8.0.0-alpha.12': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 839, 596, 46,
      5, 8, 7, 4, 2, 0, 1, 4, 2, 2, 3, 1, 2, 2, 3, 3, 1, 5, 0, 20, 10,
    ],
    '8.0.0-beta.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      260, 161, 850, 494, 1263, 998, 479, 40, 5, 3, 0, 1, 1, 2, 2, 1, 2, 0, 20, 9,
    ],
    '7.12.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 78425,
      38318, 29087, 27140, 19080, 18501, 15617, 11420, 10639, 10495, 8972, 9334,
      9843, 9942, 8686, 9019, 9238, 9144, 4170, 7364, 8177, 6338, 6725, 8179, 7848,
      7805, 8649, 8688, 6126, 7667, 8118, 7987, 7289, 7479, 8622, 11135, 10335, 9608,
      8215, 7947, 7086, 5368, 4349, 4531, 4760, 3755, 3900, 4597, 4287,
    ],
    '6.0.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2966, 22477, 10235, 9103, 7087, 7189, 7996, 7581,
      7236, 6076, 9582, 9541, 8288, 8866, 9345, 9664, 9393, 10511, 7792, 10341, 9349,
      10911, 10842, 11276, 8449, 10778, 5500, 10988, 8084, 7314, 8610, 7742, 6653,
      4771, 4038, 2674, 1104, 593, 1039, 1867, 1491, 1709, 2002, 1775, 1640, 1604,
      1513, 1199, 1386, 1373, 1343, 1367, 1438, 1338, 1031, 1092, 1071, 6463, 1301,
      1098, 1189, 1234, 3281, 1085, 1168, 1023, 960, 1155, 1100, 1048, 1052, 1039,
      862, 945, 1108, 3378, 3022, 961, 1057, 736, 928, 950, 899, 591, 820, 767, 562,
      470, 693, 808, 592, 572, 772, 519, 700, 748, 555, 759, 875, 813, 903, 700, 914,
      833, 689, 703, 497, 765, 773, 1079, 611, 852, 1110, 1024,
    ],
    '5.17.21': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 9486, 68991, 27029, 13966, 13499, 11621, 10649, 9462, 7771,
      7466, 7438, 6617, 6464, 6131, 6381, 6396, 5990, 5352, 5655, 6117, 5537, 4981,
      4764, 5354, 4856, 4453, 4097, 3833, 3887, 3858, 2006, 2957, 2984, 2618, 2752,
      3069, 3165, 2756, 2590, 2495, 1778, 903, 1518, 2508, 2701, 2407, 35414, 2369,
      2487, 2283, 8576, 2096, 2325, 2255, 1871, 1965, 1819, 1854, 1794, 1934, 1917,
      4743, 1646, 2328, 1967, 1714, 2589, 1879, 2002, 1584, 1668, 1801, 3172, 1717,
      1704, 1283, 1278, 1194, 1402, 2659, 2308, 1342, 1241, 1397, 1639, 1036, 917,
      612, 875, 1031, 616, 703, 1019, 912, 892, 1038, 929, 710, 963, 965, 851, 883,
      903, 870, 878, 1213, 1185, 875, 720, 735, 673, 673, 695, 920, 699, 796, 744,
      710,
    ],
    '7.26.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12095, 146739,
      83558, 45914, 38278, 30747, 29356, 26744, 23553, 22439, 17924, 16358, 14880,
      18553, 20113, 21390, 21800, 19421, 20350, 20335, 20296, 19753, 16524, 16971,
      18670, 19014,
    ],
    '7.18.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 140702, 80506, 67618, 55373, 46434, 44911, 41018, 43063, 39664, 37987,
      39688, 33486, 12626, 27223, 25150, 23612, 21657, 26488, 23324, 24650, 25216,
      25102, 19984, 27145, 24345, 20350, 22383, 18552, 18596, 14590, 13303, 14271,
      12770, 12483, 12456, 12400, 12890, 12811, 12872, 10247, 11610, 11229, 10084,
    ],
    '6.10.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 15120, 69460, 32268, 21890, 18745, 15594, 8387, 14875, 13650,
      14885, 12229, 11042, 7682, 5222, 5293, 4818, 2539, 1306, 2386, 4460, 3876,
      4143, 4199, 3744, 3054, 3248, 3446, 3257, 3110, 2883, 2579, 3137, 3146, 3156,
      2143, 2548, 2777, 2393, 1926, 2070, 2269, 2326, 2124, 2563, 2465, 2143, 1829,
      2054, 1978, 2041, 2159, 2694, 2015, 2193, 2318, 5099, 4539, 1486, 1357, 1830,
      1573, 1572, 1674, 796, 1604, 1622, 1487, 1566, 1608, 1435, 1454, 1463, 1409,
      1040, 1276, 1293, 1465, 1253, 1154, 1322, 1003, 1034, 1184, 1101, 1477, 1417,
      1279, 1366, 1368, 1463, 1119, 1099, 1085, 769,
    ],
    '8.0.0-alpha.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 78, 517, 7, 5, 2, 3, 2, 0, 1, 1, 2, 3, 3, 5, 5, 1,
      2, 7, 3, 3, 2, 1, 2, 2, 2, 0, 1, 2, 1, 1, 3, 3, 1, 3, 0, 20, 9,
    ],
    '4.0.0': [
      5801, 5690, 6408, 4830, 5807, 5660, 6773, 6859, 5722, 5345, 5782, 6540, 5058,
      5533, 5400, 22642, 6020, 5306, 4822, 5120, 7324, 4576, 4601, 2968, 6819, 5136,
      3947, 2180, 975, 2388, 2704, 2708, 3249, 4907, 3290, 3021, 4612, 3268, 3456,
      3733, 8765, 3249, 3115, 3184, 2892, 3041, 3074, 2903, 2898, 4585, 3324, 3279,
      3911, 3462, 3095, 3514, 3664, 3175, 2572, 2684, 2327, 3109, 1751, 2685, 25204,
      2559, 2550, 2808, 3074, 4959, 2859, 3207, 1514, 451, 1521, 2075, 2716, 2547,
      5259, 2338, 1972, 2091, 6536, 2834, 3037, 2749, 2086, 2481, 1928, 2427, 2392,
      2728, 2639, 6590, 2335, 2132, 2333, 2525, 3694, 2305, 2190, 2112, 2047, 2004,
      2201, 2070, 2151, 6449, 2141, 2086, 2013, 8504, 4175, 1646, 1969, 1629, 1382,
      1736, 1520, 647, 1698, 1893, 1567, 1941, 2186, 2069, 2120, 1973, 1293, 1158,
      1535, 1531, 1226, 1255, 1249, 1212, 1304, 1404, 1501, 1367, 1373, 1338, 1154,
      1525, 1549, 1767, 1178, 1291, 1557, 1688,
    ],
    '8.0.0-alpha.14': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 198,
      334, 295, 110, 125, 52, 59, 54, 32, 15, 17, 15, 13, 41, 23, 29, 35, 63, 84, 58,
      86, 62,
    ],
    '7.28.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 42241, 169420, 195132, 118241, 90392, 94675, 89502, 77822, 68397, 68782,
      65313, 64997, 64496, 62365, 58042, 56107, 55118, 55796,
    ],
    '6.15.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6977, 78356, 27219, 19881, 20153, 15978,
      10137, 8811, 8931, 5997, 3155, 5594, 7934, 7582, 7839, 8536, 8575, 7396, 6896,
      6570, 7161, 7511, 7624, 5386, 6294, 5569, 5314, 5486, 5737, 6669, 4842, 3358,
      3704, 3980, 3674, 3028, 2864, 2222, 2228, 2446, 2510, 2546, 1788, 2169, 3722,
      2150, 2163, 1706, 7241, 6539, 1860, 1724, 1743, 1893, 1794, 1749, 644, 1294,
      1839, 1529, 1350, 1917, 1943, 1624, 1567, 1664, 1112, 1239, 1352, 1136, 1368,
      1476, 1385, 1066, 1022, 1153, 1247, 1024, 1107, 1091, 1150, 1171, 1216, 896,
      1787, 1409, 1242,
    ],
    '6.0.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11190, 38005, 23774, 15833, 13534,
      11813, 11108, 11290, 11516, 11136, 11280, 10894, 8696, 8951, 5667, 7136, 6955,
      7038, 6683, 6588, 5692, 10437, 3374, 6485, 5801, 6313, 5171, 6221, 5677, 6247,
      7741, 9048, 3552, 1756, 4333, 9425, 7221, 6334, 6797, 8004, 5581, 6816, 6586,
      6094, 5044, 3887, 3529, 4024, 3125, 3822, 3694, 4181, 3496, 10671, 3521, 3605,
      2572, 4580, 4207, 3770, 5176, 2460, 2471, 2658, 2761, 1970, 2050, 2128, 2134,
      2015, 2160, 4642, 4186, 2099, 2079, 1941, 1936, 2134, 1581, 829, 1870, 1981,
      1643, 1877, 2321, 2355, 2205, 2064, 1898, 1694, 2041, 1883, 3286, 2231, 1642,
      1498, 1655, 1490, 2149, 1754, 1518, 1685, 1423, 2722, 2703, 2398, 2410, 4287,
      3524, 2458,
    ],
    '6.18.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 22370, 46439,
      83768, 47202, 33471, 29541, 26524, 26502, 24337, 20832, 17212, 16195, 16594,
      14362, 11216, 12626, 14371, 16237, 9338, 8541, 8508, 8576, 8350, 8035, 7685,
      7938, 6247, 6952, 5719, 7069, 6711, 7471, 7869, 6263, 6091, 5905, 6012, 6025,
      6094, 5963, 6367, 5773, 5372, 5348, 4582, 5008, 4299, 2483, 3900, 4655, 3490,
      3300, 4728, 4473, 3812, 3938, 4210, 3586, 4317, 4634, 3685, 3705, 3433, 3163,
      2773, 3442, 3049, 3425, 3642, 4280, 3564, 4702, 4677, 4037, 4259, 4462, 3750,
      3886,
    ],
    '6.2.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11765, 42377, 18688, 14669,
      12233, 11135, 9176, 8969, 9260, 7463, 7502, 5632, 6182, 6259, 5883, 5909, 5126,
      4861, 4740, 2603, 4741, 4149, 3623, 3484, 3725, 3650, 3155, 3293, 3296, 1868,
      983, 2090, 3712, 3853, 4341, 4231, 3413, 3431, 3165, 3081, 3498, 3248, 3266,
      2789, 3126, 3239, 4584, 3505, 3926, 2821, 8493, 2824, 3141, 3356, 2766, 4046,
      3221, 2811, 2421, 2494, 2739, 2560, 2018, 2630, 2326, 1796, 1494, 2055, 3238,
      3155, 1658, 2040, 1537, 1612, 1874, 1698, 873, 1564, 1747, 1535, 1335, 2149,
      1723, 1556, 1596, 1433, 982, 1060, 1275, 1127, 1266, 980, 1193, 1300, 880,
      1075, 1074, 1036, 974, 1048, 1288, 1398, 1627, 1491, 1712, 1279, 1520,
    ],
    '6.0.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8777, 31136, 11333, 8672, 9346, 10827,
      11582, 8793, 9619, 11184, 10266, 8710, 9436, 10068, 7470, 9867, 6265, 8863,
      6865, 5249, 4454, 4368, 4099, 5024, 2485, 3972, 3812, 3074, 2812, 3141, 2879,
      2208, 2164, 2470, 1446, 824, 1307, 2198, 2401, 2319, 2755, 2742, 2455, 2621,
      2379, 2575, 2699, 3282, 2718, 2221, 2456, 3234, 2830, 2772, 2231, 7363, 3102,
      2184, 1559, 1727, 2634, 1742, 1590, 1334, 1438, 1365, 1293, 1551, 1434, 1239,
      1315, 1234, 1019, 2258, 2119, 1379, 1168, 1448, 1431, 1097, 1251, 831, 1170,
      1533, 1787, 2133, 2147, 2384, 1844, 1977, 1632, 1263, 1627, 1617, 1179, 1371,
      1116, 1129, 1217, 1021, 1276, 1692, 1101, 1377, 1268, 1069, 1059, 957, 1115,
      1128, 1320, 1389,
    ],
    '7.27.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14876,
      113101, 123867, 52913, 38970, 34136, 28020, 25665, 24132, 23501, 22861, 21585,
      19426, 19520, 18298, 16985, 16768, 17201, 15977, 15386, 14985, 14802,
    ],
    '7.12.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24450,
      74660, 34709, 26280, 20100, 17599, 14818, 14292, 11655, 12061, 9895, 9401,
      9623, 10574, 7889, 8978, 9107, 10245, 4029, 7515, 8973, 6960, 7180, 7038, 7250,
      6178, 6504, 7840, 5343, 6519, 6777, 6842, 6119, 5648, 5811, 5357, 6180, 5750,
      6009, 5136, 4295, 4186, 4277, 4404, 4632, 4500, 4552, 4663, 4391,
    ],
    '7.0.0-alpha.6': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 167, 117, 220, 104,
      113, 115, 108, 77, 15, 20, 18, 10, 8, 12, 8, 5, 7, 9, 8, 10, 11, 14, 14, 14,
      14, 13, 18, 17, 16, 16, 15, 14, 16, 16, 14, 1, 1, 1, 1, 2, 3, 1, 1, 0, 0, 2, 0,
      1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 2, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 0, 0, 1, 2, 2,
      1, 1, 0, 20, 8,
    ],
    '7.6.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5895, 1746, 927, 979, 851, 765,
      798, 540, 297, 277, 239, 333, 222, 294, 208, 197, 174, 224, 192, 177, 97, 104,
      128, 95, 107, 119, 74, 124, 111, 87, 98, 104, 63, 99, 120, 158, 99, 142, 152,
      131, 187, 189, 316, 224, 167, 245, 127, 360, 219, 165, 255, 255, 211, 105, 84,
      150, 100,
    ],
    '7.0.0-alpha.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 198, 69, 51, 3, 4, 5, 20,
      22, 28, 8, 14, 10, 9, 10, 5, 7, 11, 11, 5, 8, 9, 7, 6, 11, 15, 14, 14, 13, 19,
      22, 17, 17, 15, 14, 14, 16, 16, 17, 1, 1, 1, 1, 3, 3, 1, 1, 1, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 1, 2, 1, 0, 0, 1, 0, 1, 2, 0, 0, 1, 0, 0, 1, 2, 2, 1, 4,
      0, 20, 8,
    ],
    '5.17.14': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15780,
      77915, 89101, 46986, 16666, 29167, 36516, 33436, 44803, 31914, 28439, 29593,
      23732, 26945, 25357, 24148, 20573, 21682, 22690, 24210, 20864, 22753, 20420,
      25956, 24558, 22705, 27352, 27884, 20023, 22317, 21873, 27534, 25156, 21613,
      20801, 21120, 21074, 21414, 8362, 13263, 13569, 12333, 12206, 11404, 12351,
      11376, 11530, 11389, 6144, 2308, 6207, 9878, 9029, 10686, 23599, 9740, 8685,
      8195, 62502, 54303, 8512, 9381, 8467, 8774, 9734, 10435, 9960, 10095, 7394,
      20058, 8111, 7046, 8854, 10322, 12006, 8434, 9998, 8664, 9434, 7646, 5918,
      5115, 6251, 5965, 5144, 4557, 5529, 10753, 19499, 3562, 4394, 3251, 3856, 3829,
      3910, 2133, 4032, 5430, 4477, 5795, 28886, 10762, 4916, 6245, 5353, 3691, 4868,
      7305, 6481, 5819, 5199, 5576, 10909, 8786, 8300, 9264, 7150, 5993, 9550, 6297,
      6260, 5319, 3685, 3604, 4507, 3942,
    ],
    '6.9.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      15333, 65303, 26213, 19473, 13811, 12313, 11069, 9427, 8943, 8257, 4214, 6306,
      5040, 4567, 4510, 4530, 4195, 4277, 3919, 4097, 3123, 1338, 2349, 3548, 3445,
      3536, 3804, 3518, 3096, 2973, 3095, 3310, 3321, 3152, 2579, 3042, 2749, 2693,
      2457, 2597, 2523, 2601, 2370, 2540, 2291, 2204, 11080, 2432, 2525, 3168, 2504,
      2330, 2258, 2244, 2163, 1994, 1954, 2226, 2267, 4196, 3880, 2212, 2281, 1814,
      2002, 2203, 2125, 860, 1656, 2176, 1867, 1971, 2495, 2564, 1932, 2065, 1880,
      1791, 2151, 2203, 3562, 17648, 20414, 17952, 12177, 18950, 18152, 14672, 13182,
      13699, 12756, 12059, 11911, 13909, 15254, 13445, 12958, 14989,
    ],
    '5.17.9': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19580, 58278, 27325,
      18565, 13447, 13424, 12650, 11971, 9492, 5709, 8988, 10492, 10405, 10504,
      11161, 11763, 8882, 8221, 8093, 7842, 7464, 6100, 6199, 6791, 5917, 5741, 5403,
      6215, 5906, 5476, 5471, 5898, 6096, 5002, 5130, 4885, 4981, 4515, 4842, 4712,
      4899, 4970, 4228, 2612, 4026, 3607, 3461, 3533, 3648, 3689, 5910, 3048, 2635,
      1985, 1272, 2121, 2724, 2629, 2559, 6421, 2787, 2592, 2562, 6647, 2470, 2271,
      2369, 1889, 2406, 1969, 2295, 2249, 2489, 2053, 5740, 2455, 2582, 2414, 2840,
      3672, 2568, 2258, 2085, 2088, 2258, 2317, 2035, 2263, 2366, 2129, 2076, 1681,
      22807, 16548, 1786, 1687, 1774, 2139, 1870, 1453, 889, 1652, 1798, 1503, 1621,
      1823, 1577, 1994, 1772, 1537, 1404, 1836, 1487, 1527, 1591, 1210, 1332, 1471,
      1539, 1445, 1263, 1084, 1064, 1421, 1359, 1364, 1412, 1044, 1133, 1265, 1097,
    ],
    '7.3.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11439, 17039, 14849, 14594, 12578, 10870,
      9278, 8828, 8112, 8088, 8236, 7667, 7439, 8499, 8737, 7389, 8989, 8561, 7088,
      8126, 7608, 6865, 7047, 6202, 6354, 7574, 6904, 6485, 6414, 7585, 3262, 6389,
      7899, 7776, 8488, 9633, 11570, 9529, 11963, 7932, 7181, 8515, 9518, 10126,
      7371, 6135, 4278, 3195, 4547, 6743, 9121, 6653, 8550, 6411, 6164, 6283, 8647,
      6637, 4310, 1795, 1561,
    ],
    '7.27.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 63560,
      24917, 12679, 14821, 12486, 11805, 11479, 10430, 7939, 6697, 7362, 7820, 7167,
      6555, 7074, 5490, 6375, 6358, 6646, 5157, 5982, 5554, 4777,
    ],
    '5.13.0': [
      0, 0, 0, 10493, 47639, 27095, 30106, 25552, 23067, 20482, 15544, 12079, 11341,
      12023, 10825, 10283, 8629, 8227, 7950, 7853, 7347, 7582, 7148, 5183, 6479,
      6107, 6683, 5222, 2353, 4732, 5922, 5334, 6477, 5301, 5460, 5541, 5425, 5462,
      5224, 5458, 4327, 4068, 4506, 3943, 4252, 4166, 3839, 4307, 4015, 3845, 5281,
      4844, 4969, 4107, 3459, 4821, 4996, 4061, 4893, 4011, 4252, 3854, 2576, 3865,
      13152, 4028, 3840, 3845, 3664, 4622, 2885, 3022, 2203, 911, 1396, 3280, 3243,
      3605, 5950, 3024, 3349, 3521, 5980, 3547, 3526, 3630, 2570, 2579, 2398, 2815,
      2713, 3292, 3252, 4836, 3052, 2666, 1902, 2399, 2856, 2334, 2412, 2323, 2491,
      2316, 2528, 2089, 2114, 3828, 2167, 2260, 2300, 7378, 5229, 2667, 2777, 1937,
      2212, 2718, 2336, 1073, 2371, 2185, 1682, 1786, 2156, 2499, 1848, 2441, 2325,
      1861, 2527, 2169, 2252, 1855, 2021, 1835, 2315, 2154, 2150, 2203, 2256, 2307,
      2756, 2132, 2135, 2847, 1920, 2671, 2558, 2815,
    ],
    '6.19.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      31835, 121762, 52719, 36454, 32498, 29892, 28442, 25528, 19564, 22392, 26162,
      21870, 14801, 14538, 12437, 11394, 10469, 9555, 10332, 9099, 9405, 9670, 9228,
      9372, 8689, 7560, 6914, 7055, 7575, 6420, 6651, 6103, 5682, 6226, 6258, 5129,
      6155, 5243, 5466, 4947, 5504, 2545, 4132, 4328, 3871, 3963, 4112, 4138, 4381,
      4447, 4502, 3666, 4607, 4764, 5081, 4240, 3756, 3204, 3002, 3381, 3518, 3303,
      2924, 2917, 2949, 2974, 2813, 2946, 3086, 2877, 3165, 2769,
    ],
    '5.11.0': [
      21736, 19947, 19044, 12073, 18087, 12050, 13382, 12438, 11652, 11061, 12443,
      10103, 10974, 12075, 12786, 9440, 10263, 11009, 10660, 12722, 11563, 11544,
      14077, 14010, 12620, 10496, 9344, 8970, 9958, 9730, 11502, 12270, 13489, 15413,
      18149, 18132, 12699, 12803, 13600, 11974, 10255, 10607, 10295, 10660, 9031,
      9362, 9008, 10795, 7737, 19737, 9788, 10283, 12287, 10616, 8882, 11580, 10553,
      11583, 14356, 14674, 9755, 11467, 5001, 7156, 20859, 10587, 6566, 7576, 10435,
      8127, 5986, 7056, 5791, 3996, 3256, 6431, 5976, 6210, 10078, 4790, 2215, 4118,
      10171, 1287, 1020, 874, 822, 860, 1124, 1022, 740, 970, 1002, 21440, 928, 897,
      949, 1137, 5411, 998, 1093, 2646, 2135, 2696, 2269, 2389, 3061, 6109, 2989,
      3985, 2564, 13988, 11092, 4987, 4718, 4281, 3812, 3832, 4471, 1965, 3262, 2937,
      1630, 1806, 2689, 2096, 1743, 1354, 1585, 1122, 1355, 2052, 2092, 1602, 1315,
      1210, 948, 1014, 1073, 867, 629, 671, 512, 665, 665, 659, 724, 632, 678, 755,
    ],
    '7.0.0-alpha.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 132, 228, 172, 45, 12, 19,
      26, 24, 21, 11, 15, 23, 21, 22, 5, 8, 12, 8, 7, 7, 10, 7, 6, 14, 14, 14, 14,
      13, 13, 18, 17, 16, 15, 14, 14, 16, 16, 19, 1, 1, 1, 1, 7, 2, 1, 1, 0, 0, 0, 1,
      1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 3, 2, 0, 1, 2, 0, 0, 1, 2, 2,
      1, 3, 1, 20, 8,
    ],
    '8.0.0-alpha.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 226, 352, 12, 8, 8, 0, 4, 23,
      38, 20, 47, 53, 30, 31, 8, 2, 3, 0, 0, 11, 0, 1, 1, 2, 2, 7, 21, 0, 32, 73,
    ],
    '7.23.2': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28363, 101741, 17663, 27098, 23774,
      17474, 15384, 14928, 14095, 13132, 11718, 10284, 9397, 11497, 11106, 10958,
      24887, 27763, 24461, 17181, 23676, 22576, 19811, 17899, 18097, 16859, 16624,
      16423, 18544, 18755, 17129, 15863, 17922,
    ],
    '7.1.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 7946, 58579, 27932, 8492, 9002, 7450, 7122, 6528,
      6432, 4912, 5465, 4653, 4894, 4729, 5374, 5063, 4630, 4416, 3423, 3889, 3895,
      3550, 3249, 3393, 2728, 3024, 3657, 3831, 3011, 3442, 2911, 2457, 839, 2281,
      2787, 2383, 2737, 3703, 4602, 3280, 3380, 2702, 2672, 3763, 3379, 3516, 3718,
      2052, 2136, 2051, 2333, 2707, 2793, 2120, 1627, 1872, 1711, 1708, 1925, 1475,
      2001, 1449, 1527,
    ],
    '7.29.4': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 26241, 58329, 27436, 20589, 18210, 18397, 12375,
      10244, 11540, 10257, 8469,
    ],
    '6.0.0-beta.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 146, 36, 44, 31, 87, 25, 6, 6, 18, 12, 24, 4, 2, 5, 4,
      12, 18, 1, 2, 5, 7, 5, 3, 3, 4, 1, 3, 0, 5, 0, 7, 12, 2, 1, 2, 2, 2, 3, 1, 2,
      1, 12, 20, 16, 6, 11, 12, 9, 33, 5, 7, 10, 8, 5, 7, 9, 9, 8, 13, 16, 14, 16,
      17, 14, 21, 17, 16, 16, 15, 17, 19, 18, 15, 5, 3, 0, 1, 11, 5, 2, 3, 0, 0, 8,
      1, 0, 2, 1, 0, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 0, 3, 2, 0, 1, 1, 0, 0, 1, 2,
      2, 1, 0, 0, 21, 8,
    ],
    '6.0.0-alpha.3': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 126, 536, 5, 6, 3, 2, 0, 0,
      2, 0, 0, 2, 1, 0, 1, 0, 2, 2, 2, 1, 2, 3, 2, 3, 4, 4, 1, 1, 1, 3, 4, 2, 3, 1,
      1, 1, 0, 4, 4, 3, 3, 4, 1, 3, 3, 2, 0, 7, 12, 2, 1, 2, 2, 2, 1, 1, 2, 4, 13,
      18, 16, 5, 11, 10, 7, 11, 5, 7, 10, 8, 5, 7, 9, 7, 6, 11, 14, 14, 14, 14, 13,
      18, 17, 16, 15, 14, 15, 17, 18, 13, 5, 3, 3, 1, 5, 4, 2, 1, 0, 0, 2, 0, 0, 0,
      1, 0, 0, 2, 0, 0, 1, 1, 0, 1, 0, 1, 0, 1, 1, 2, 0, 0, 1, 0, 0, 1, 2, 2, 1, 1,
      1, 20, 7,
    ],
    '6.0.0-alpha.10': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 144,
      508, 196, 159, 206, 210, 176, 110, 138, 205, 156, 153, 125, 46, 8, 4, 3, 6, 11,
      3, 6, 7, 9, 11, 3, 4, 2, 2, 1, 3, 12, 8, 3, 3, 5, 2, 3, 0, 2, 3, 9, 12, 8, 3,
      5, 5, 9, 8, 3, 2, 1, 14, 18, 17, 99, 11, 10, 7, 73, 5, 8, 10, 8, 8, 9, 9, 7, 6,
      13, 14, 14, 14, 14, 16, 19, 17, 17, 15, 14, 15, 17, 18, 13, 4, 2, 0, 1, 3, 5,
      1, 1, 1, 0, 4, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 1, 1, 0, 1, 3, 4, 0,
      1, 0, 0, 1, 2, 2, 1, 0, 0, 20, 9,
    ],
    '7.0.0-alpha.9': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 147,
      254, 316, 331, 315, 349, 226, 174, 39, 179, 120, 7, 12, 15, 26, 13, 15, 20, 14,
      14, 13, 14, 18, 18, 17, 15, 14, 15, 16, 16, 13, 1, 3, 3, 1, 1, 2, 2, 4, 0, 1,
      0, 0, 0, 1, 0, 1, 1, 1, 0, 0, 0, 0, 2, 1, 1, 0, 2, 0, 0, 1, 0, 0, 1, 0, 0, 1,
      2, 2, 1, 2, 1, 20, 8,
    ],
    '7.29.7': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12634, 80361, 36762, 25687, 27915,
    ],
    '8.6.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6127, 71325, 37725, 28202, 19984,
    ],
    '7.29.8': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4379, 78524, 109897, 150896,
    ],
    '8.7.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4329, 67136, 34753, 21979,
    ],
    '8.8.0': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6072, 74206, 46823,
    ],
    '8.9.1': [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64714,
    ],
  },
};
